// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/primeng/resources/themes/lara-light-blue/theme.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/primeng/resources/primeng.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/@ali-hm/angular-tree-component/css/angular-tree-component.css");
var ___CSS_LOADER_AT_RULE_IMPORT_3___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/@angular/material/prebuilt-themes/indigo-pink.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* You can add global styles to this file, and also import other style files */
/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #1161be;
  --secondary: #6c757d;
  --success: #1ba953;
  --info: #1161be;
  --warning: #fbcd1e;
  --danger: #f64540;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 1px;
  --breakpoint-md: 2px;
  --breakpoint-lg: 3px;
  --breakpoint-xl: 100px;
  --font-family-sans-serif: "Noto Sans";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Noto Sans";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #252525;
  text-align: left;
  background-color: #f7f8fc;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #1161be;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: bold;
  line-height: 1.2;
  color: #252525;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f7f8fc;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 1px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 2px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 3px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 100px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 1px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 2px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 3px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 100px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #252525;
  background-color: #fff;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f7f8fc;
}

.table-hover tbody tr:hover {
  color: #252525;
  background-color: rgba(0, 123, 255, 0.2);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #bcd3ed;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #83addd;
}

.table-hover .table-primary:hover {
  background-color: #a8c6e8;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #a8c6e8;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover {
  background-color: #c8cbcf;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #bfe7cf;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #88d2a6;
}

.table-hover .table-success:hover {
  background-color: #ace0c1;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #ace0c1;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bcd3ed;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #83addd;
}

.table-hover .table-info:hover {
  background-color: #a8c6e8;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a8c6e8;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fef1c0;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fde58a;
}

.table-hover .table-warning:hover {
  background-color: #feeba7;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #feeba7;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fccbca;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #fa9e9c;
}

.table-hover .table-danger:hover {
  background-color: #fbb3b2;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #fbb3b2;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcfc;
}

.table-hover .table-light:hover {
  background-color: #ececf6;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 123, 255, 0.3);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 111, 230, 0.3);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 111, 230, 0.3);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 0.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 2.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 99.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: none;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  -webkit-appearance: none;
          appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #252525;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 1px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #252525;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #252525;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: none;
}
.btn.disabled, .btn:disabled {
  opacity: 0.35;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-primary:hover {
  color: #fff;
  background-color: #0e4f9b;
  border-color: #0d498f;
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: #0e4f9b;
  border-color: #0d498f;
  box-shadow: 0 0 0 0.2rem rgba(53, 121, 200, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0d498f;
  border-color: #0c4383;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(53, 121, 200, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #1ba953;
  border-color: #1ba953;
}
.btn-success:hover {
  color: #fff;
  background-color: #168843;
  border-color: #147d3d;
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #168843;
  border-color: #147d3d;
  box-shadow: 0 0 0 0.2rem rgba(61, 182, 109, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #1ba953;
  border-color: #1ba953;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #147d3d;
  border-color: #127238;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(61, 182, 109, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-info:hover {
  color: #fff;
  background-color: #0e4f9b;
  border-color: #0d498f;
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #0e4f9b;
  border-color: #0d498f;
  box-shadow: 0 0 0 0.2rem rgba(53, 121, 200, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0d498f;
  border-color: #0c4383;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(53, 121, 200, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #fbcd1e;
  border-color: #fbcd1e;
}
.btn-warning:hover {
  color: #212529;
  background-color: #efbe04;
  border-color: #e2b404;
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: #efbe04;
  border-color: #e2b404;
  box-shadow: 0 0 0 0.2rem rgba(218, 180, 32, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #fbcd1e;
  border-color: #fbcd1e;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #e2b404;
  border-color: #d5aa04;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(218, 180, 32, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f64540;
  border-color: #f64540;
}
.btn-danger:hover {
  color: #fff;
  background-color: #f4211b;
  border-color: #f4160f;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #f4211b;
  border-color: #f4160f;
  box-shadow: 0 0 0 0.2rem rgba(247, 97, 93, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f64540;
  border-color: #f64540;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #f4160f;
  border-color: #eb110b;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(247, 97, 93, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-outline-primary {
  color: #1161be;
  border-color: #1161be;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #1161be;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #1ba953;
  border-color: #1ba953;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #1ba953;
  border-color: #1ba953;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(27, 169, 83, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #1ba953;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #1ba953;
  border-color: #1ba953;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(27, 169, 83, 0.5);
}

.btn-outline-info {
  color: #1161be;
  border-color: #1161be;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #1161be;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #1161be;
  border-color: #1161be;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}

.btn-outline-warning {
  color: #fbcd1e;
  border-color: #fbcd1e;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #fbcd1e;
  border-color: #fbcd1e;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(251, 205, 30, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fbcd1e;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #fbcd1e;
  border-color: #fbcd1e;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(251, 205, 30, 0.5);
}

.btn-outline-danger {
  color: #f64540;
  border-color: #f64540;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f64540;
  border-color: #f64540;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(246, 69, 64, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f64540;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f64540;
  border-color: #f64540;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(246, 69, 64, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #1161be;
  text-decoration: none;
}
.btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #252525;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 1px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 2px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 3px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 100px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #80bdff;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e");
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e");
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
          appearance: none;
}
.custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f7f8fc, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f7f8fc, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f7f8fc, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #f7f8fc;
  border-color: #dee2e6 #dee2e6 #f7f8fc;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 2rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 2rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 0.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 2px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 2.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 3px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 99.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 100px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: #252525;
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: #0056b3;
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(37, 37, 37, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: #0056b3;
}
.navbar-light .navbar-toggler {
  color: #252525;
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
.navbar-light .navbar-text {
  color: #252525;
}
.navbar-light .navbar-text a {
  color: #0056b3;
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: #0056b3;
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #f7f8fc;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 1px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 1px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 1px) {
  .card-columns {
    -moz-column-count: 3;
         column-count: 3;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #1161be;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #0d498f;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: #545b62;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #1ba953;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: #147d3d;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(27, 169, 83, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #1161be;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: #0d498f;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(17, 97, 190, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #fbcd1e;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: #e2b404;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(251, 205, 30, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #f64540;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #f4160f;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(246, 69, 64, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: #dae0e5;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: #1d2124;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 1px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #093263;
  background-color: #cfdff2;
  border-color: #bcd3ed;
}
.alert-primary hr {
  border-top-color: #a8c6e8;
}
.alert-primary .alert-link {
  color: #051a34;
}

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db;
}
.alert-secondary hr {
  border-top-color: #c8cbcf;
}
.alert-secondary .alert-link {
  color: #202326;
}

.alert-success {
  color: #0e582b;
  background-color: #d1eedd;
  border-color: #bfe7cf;
}
.alert-success hr {
  border-top-color: #ace0c1;
}
.alert-success .alert-link {
  color: #072c16;
}

.alert-info {
  color: #093263;
  background-color: #cfdff2;
  border-color: #bcd3ed;
}
.alert-info hr {
  border-top-color: #a8c6e8;
}
.alert-info .alert-link {
  color: #051a34;
}

.alert-warning {
  color: #836b10;
  background-color: #fef5d2;
  border-color: #fef1c0;
}
.alert-warning hr {
  border-top-color: #feeba7;
}
.alert-warning .alert-link {
  color: #56460a;
}

.alert-danger {
  color: #802421;
  background-color: #fddad9;
  border-color: #fccbca;
}
.alert-danger hr {
  border-top-color: #fbb3b2;
}
.alert-danger .alert-link {
  color: #571917;
}

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe;
}
.alert-light hr {
  border-top-color: #ececf6;
}
.alert-light .alert-link {
  color: #686868;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}
.alert-dark hr {
  border-top-color: #b9bbbe;
}
.alert-dark .alert-link {
  color: #040505;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #252525;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 1px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 2px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 3px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 100px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #093263;
  background-color: #bcd3ed;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #093263;
  background-color: #a8c6e8;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #093263;
  border-color: #093263;
}

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #383d41;
  background-color: #c8cbcf;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #383d41;
  border-color: #383d41;
}

.list-group-item-success {
  color: #0e582b;
  background-color: #bfe7cf;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #0e582b;
  background-color: #ace0c1;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #0e582b;
  border-color: #0e582b;
}

.list-group-item-info {
  color: #093263;
  background-color: #bcd3ed;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #093263;
  background-color: #a8c6e8;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #093263;
  border-color: #093263;
}

.list-group-item-warning {
  color: #836b10;
  background-color: #fef1c0;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #836b10;
  background-color: #feeba7;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #836b10;
  border-color: #836b10;
}

.list-group-item-danger {
  color: #802421;
  background-color: #fccbca;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #802421;
  background-color: #fbb3b2;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #802421;
  border-color: #802421;
}

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #818182;
  background-color: #ececf6;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #818182;
  border-color: #818182;
}

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #1b1e21;
  background-color: #b9bbbe;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #1b1e21;
  border-color: #1b1e21;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 1px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 3px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 100px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #252525;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #252525;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #1161be !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #0d498f !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}

.bg-success {
  background-color: #1ba953 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #147d3d !important;
}

.bg-info {
  background-color: #1161be !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0d498f !important;
}

.bg-warning {
  background-color: #fbcd1e !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #e2b404 !important;
}

.bg-danger {
  background-color: #f64540 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #f4160f !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dae0e5 !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #1161be !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #1ba953 !important;
}

.border-info {
  border-color: #1161be !important;
}

.border-warning {
  border-color: #fbcd1e !important;
}

.border-danger {
  border-color: #f64540 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 1px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 2px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 3px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 100px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 1px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 2px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 3px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 100px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 1px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 2px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 3px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 100px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 1px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 2px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 3px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 100px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 1px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 2px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 3px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 100px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #1161be !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #0b3d78 !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #494f54 !important;
}

.text-success {
  color: #1ba953 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #106733 !important;
}

.text-info {
  color: #1161be !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0b3d78 !important;
}

.text-warning {
  color: #fbcd1e !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #c9a004 !important;
}

.text-danger {
  color: #f64540 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #df100b !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: #cbd3da !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: #121416 !important;
}

.text-body {
  color: #252525 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}
.notifier__container * {
  box-sizing: border-box;
}
.notifier__container-list {
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  list-style-type: none;
}
.notifier__notification {
  display: flex;
  align-items: center;
  position: fixed;
  visibility: hidden;
  z-index: 10000;
  will-change: transform;
  backface-visibility: hidden;
}

.notifier__notification--material {
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  cursor: default;
  padding-top: 11px;
  padding-right: 26px;
  padding-bottom: 10px;
  padding-left: 26px;
}
.notifier__notification--material .notifier__notification-message {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0;
  vertical-align: top;
  line-height: 32px;
  font-size: 15px;
}
.notifier__notification--material .notifier__notification-button {
  display: inline-block;
  transition: opacity 0.2s ease;
  opacity: 0.5;
  margin-right: -10px;
  margin-left: 10px;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
  width: 32px;
  height: 32px;
  vertical-align: top;
}
.notifier__notification--material .notifier__notification-button:hover, .notifier__notification--material .notifier__notification-button:focus {
  opacity: 1;
}
.notifier__notification--material .notifier__notification-button:active {
  transform: scale(0.82);
  opacity: 1;
}

.notifier__notification--default {
  background-color: #444;
  color: #fff;
}
.notifier__notification--default .notifier__notification-button-icon {
  fill: #fff;
}

.notifier__notification--error {
  background-color: #d9534f;
  color: #fff;
}
.notifier__notification--error .notifier__notification-button-icon {
  fill: #fff;
}

.notifier__notification--info {
  background-color: #5bc0de;
  color: #fff;
}
.notifier__notification--info .notifier__notification-button-icon {
  fill: #fff;
}

.notifier__notification--success {
  background-color: #5cb85c;
  color: #fff;
}
.notifier__notification--success .notifier__notification-button-icon {
  fill: #fff;
}

.notifier__notification--warning {
  background-color: #f0ad4e;
  color: #fff;
}
.notifier__notification--warning .notifier__notification-button-icon {
  fill: #fff;
}

/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
body {
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

/* Bootstrap overrides */
.table thead th {
  border: none;
}

table.fixed-layout {
  table-layout: fixed;
}

td.vertical-align-middle {
  vertical-align: middle !important;
}

h1 {
  font-family: "Noto Sans";
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 0;
}

h2 {
  font-family: "Noto Sans";
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 0;
}

h3 {
  font-family: "Noto Sans";
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}

h4 {
  font-family: "Noto Sans";
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}

h5 {
  font-family: "Noto Sans";
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
}

h6 {
  font-family: "Noto Sans";
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
}

.btn {
  font-weight: bold;
  border-width: 2px;
}

a.btn {
  font-size: 1rem;
}

.btn-secondary {
  background-color: #8291ae;
  border-color: #8291ae;
}

.btn-outline-secondary {
  color: #8291ae;
  border-color: #8291ae;
}

a.link,
a.link:not([href]):not([tabindex]) {
  font-size: 14px;
  font-weight: bold;
  color: #1161be;
  cursor: pointer;
}

a.link-danger {
  font-size: 14px;
  font-weight: bold;
  color: #f64540 !important;
  cursor: pointer;
}

a.link:hover {
  color: #0056b3;
}

a.in-text-link {
  font-size: 14px !important;
  font-weight: normal !important;
  text-decoration: none !important;
  color: #1161be;
  cursor: pointer;
}

.bs-datepicker.archived-task-range {
  right: 126px;
}

.bs-datepicker.report-range {
  top: 2px;
  left: 180px;
}

tabset {
  background-color: #fff;
}
tabset ul.nav-tabs {
  background-color: #fff;
}
tabset ul.nav-tabs a.nav-link {
  border-width: 0 0 2px 0;
  border-bottom: 2px solid transparent;
  color: rgba(0, 0, 0, 0.87);
  font-family: "Noto Sans";
  font-size: 18px;
  font-weight: bold;
  min-width: 160px;
  padding: 7px 24px;
  text-align: center;
}
tabset ul.nav-tabs a.nav-link.active,
tabset ul.nav-tabs a.nav-link:hover {
  /*border-bottom: 2px solid rgba(0, 0, 0, .87);*/
}
tabset ul.nav-tabs a.nav-link.active {
  background-color: #fff;
  color: #1161be;
  border-bottom: 2px solid #1161be;
}

.bck-white {
  background: #fff;
}

.bck-gray {
  background: #f7f8fc;
}

.bck-blue {
  background: #1161be;
  color: #fff;
}

.bck-blue-light {
  background: #e1eefe;
}

.cursor-pointer {
  cursor: pointer;
}

.white-box {
  background-color: #fff;
  padding: 1.5rem;
}

.blue-box {
  background-color: #e1eefe;
  padding: 1rem 1.5rem;
}

.light-gray-box {
  background-color: #f7f8fc;
  padding: 0.75rem;
}

.card-body .main-container {
  padding: 34px;
}

input.rtl {
  direction: rtl;
}

.flex-grow {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.no-flex-shrink {
  flex-shrink: 0;
}

.navbar {
  z-index: 100;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.wide-modal {
  max-width: 60vw !important;
}

.remove-icon {
  color: #f64540;
  cursor: pointer;
}

.disabled-icon {
  color: #8291ae;
}

.input-group.with-icon input.form-control {
  border-right-width: 0;
}
.input-group.with-icon .input-group-text {
  background-color: #fff;
}

.badge.badge-button {
  position: absolute;
  top: -10px;
  right: -10px;
  display: block;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  padding: 0 0.4em;
}

a.disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.35;
}

.task-tags {
  height: 18px;
  line-height: 0;
  padding: 0;
}

.task-tag {
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 9px;
  margin-right: 5px;
}

.task-tag.category {
  color: #8291ae;
  background-color: #e6e9f0;
}

.task-tag.type {
  color: #151b26;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-decoration-underline {
  text-decoration: underline;
}

[ng-reflect-router-link] {
  cursor: pointer;
}

i-feather.blue-icon {
  color: #1161be;
  cursor: pointer;
}

i-feather.white-icon {
  color: #fff;
  cursor: pointer;
}

.modal-dialog.modal-image {
  width: auto;
  max-width: initial;
}
.modal-dialog.modal-image .modal-content {
  width: auto;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0;
}

.float-right {
  float: right;
}

.color-yellow {
  color: #fbcd1e;
}

@keyframes loading-indicator {
  to {
    transform: rotate(360deg);
  }
}
.loading-indicator {
  position: relative;
}

.loading-indicator .blocker {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: progress;
  background-color: rgba(255, 255, 255, 0.7);
}

.loading-indicator::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #07d;
  border-bottom-color: #07d;
  animation: 0.6s linear infinite loading-indicator;
  z-index: 2;
}

.loading-indicator.for-dropdown::after {
  bottom: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}

.loading-indicator.for-element::after {
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  width: 30px;
  height: 30px;
  background-color: transparent;
}

.star-icon, .star-icon::before {
  font-size: 1em !important;
  color: #8291ae !important;
}

.notifier__container {
  position: absolute;
  top: 0;
  left: 0;
}

table.table {
  margin-bottom: initial;
}

.sidenav-content {
  height: 100%;
}
.sidenav-content .sidenav-body {
  padding: 25px 20px;
  height: calc(100% - 60.5px);
  overflow-y: auto;
}
.sidenav-content .sidenav-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px 20px;
}

/* structure components styling */
.Country-list {
  border-right: solid 1px #e1eefe;
  height: calc(100vh - 215px);
}

.Country-item {
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 -1px 0 0 #e1eefe;
}

.Country-header {
  font-size: 18px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-weight: bold;
}

.country-detail-item {
  color: #fff;
  padding-left: 10px;
  margin-top: 20px;
  padding-top: 8px;
  background: #1161be;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.governorate-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  color: #1161be;
  background: #bee7ff;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.district-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  color: #1161be;
  background: #e1eefe;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.unit-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  background: #f7f8fc;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

ul.org-unit {
  list-style: none;
}

ul.org-unit li::before {
  content: " ";
  color: #1161be;
  font-size: 0px;
  /* font-weight: bold; */
  display: inline-block;
  position: relative;
  right: 35px;
  top: -3px;
  /* margin-left: 20em; */
  background: #1161be;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

ul.org-unit li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 16px;
  position: relative;
  display: block;
  left: -50px;
}

ul.org-unit > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 55px;
  position: relative;
  display: block;
  left: -90px;
}

ul.org-unit {
  margin-bottom: 0 !important;
}

.no-children {
  width: 32px;
  height: 30px;
}

ul.org-unit > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 95px;
  position: relative;
  display: block;
  left: -130px;
}

ul.org-unit > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 135px;
  position: relative;
  display: block;
  left: -170px;
}

ul.org-unit > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 175px;
  position: relative;
  display: block;
  left: -210px;
}

ul.org-unit > ul > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 215px;
  position: relative;
  display: block;
  left: -250px;
}

ul.org-unit > ul > ul > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 255px;
  position: relative;
  display: block;
  left: -290px;
}

.nav-link.country-name {
  padding: 0;
}

.country-name-container {
  list-style-type: none;
  padding: 0;
}

.country-name-container a {
  color: white;
}

.country-name-container .nav-link {
  color: #292727;
}

body {
  overflow-x: hidden;
}

.board-task-filter-datepicker-container .bs-datepicker-container {
  margin-right: 135px;
}

div.multiselect-dropdown span.dropdown-btn span.selected-item span {
  white-space: nowrap;
}

.task-groups .multiselect-dropdown .dropdown-list {
  transform: translateY(-112%);
  overflow: hidden;
}

.visually-hidden {
  display: none;
}

app-task-edit typeahead-container {
  width: calc(100% - 30px);
  height: 200px !important;
}

@media (max-width: 960px) {
  .formio-component-datagrid {
    width: 100%;
    position: relative;
    overflow-x: auto;
  }
  .formio-component-datagrid table {
    min-width: 750px;
  }
  .datagrid-table > tbody > tr > td {
    word-break: normal !important;
  }
  .datagrid-table th {
    min-width: 250px !important;
  }
  .datagrid-table th:last-of-type {
    min-width: auto !important;
  }
  .choices__item.choices__item--selectable {
    text-overflow: inherit !important;
    overflow: visible;
  }
}
.modal-dialog {
  width: 60vw !important;
}

.company-detail-item {
  color: #fff;
  padding-left: 10px;
  margin-top: 0px;
  padding-top: 8px;
  background: #1161be;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/modal-choose-company/modal-choose-company.component.scss","webpack://./src/styles/styles.scss","webpack://./src/styles/_variables.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./node_modules/angular-notifier/styles/core.scss","webpack://./node_modules/angular-notifier/styles/themes/theme-material.scss","webpack://./node_modules/angular-notifier/styles/types/type-default.scss","webpack://./node_modules/angular-notifier/styles/types/type-error.scss","webpack://./node_modules/angular-notifier/styles/types/type-info.scss","webpack://./node_modules/angular-notifier/styles/types/type-success.scss","webpack://./node_modules/angular-notifier/styles/types/type-warning.scss","webpack://./src/styles/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,8EAAA;ACCA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AChMA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,sBAAA;EAKF,qCAAA;EACA,6GAAA;AJqCF;;AKpCA;;;EAGE,sBAAA;ALuCF;;AKpCA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;ALuCF;;AKjCA;EACE,cAAA;ALoCF;;AK1BA;EACE,SAAA;EACA,wBHIgB;EIiIZ,eAAA;EDnIJ,gBE+O4B;EF9O5B,gBEmP4B;EFlP5B,cHtCc;EGuCd,gBAAA;EACA,yBHtCe;AFmEjB;;AKjBA;EACE,qBAAA;ALoBF;;AKXA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;ALcF;;AKDA;EACE,aAAA;EACA,qBEiN4B;AP7M9B;;AKGA;EACE,aAAA;EACA,mBEoF0B;APpF5B;;AKWA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;ALRF;;AKWA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALRF;;AKWA;;;EAGE,aAAA;EACA,mBAAA;ALRF;;AKWA;;;;EAIE,gBAAA;ALRF;;AKWA;EACE,gBEkJ4B;AP1J9B;;AKWA;EACE,qBAAA;EACA,cAAA;ALRF;;AKWA;EACE,gBAAA;ALRF;;AKWA;;EAEE,mBEqI4B;AP7I9B;;AKWA;ECII,cAAA;ANXJ;;AKgBA;;EAEE,kBAAA;ECPE,cAAA;EDSF,cAAA;EACA,wBAAA;ALbF;;AKgBA;EAAM,eAAA;ALZN;;AKaA;EAAM,WAAA;ALTN;;AKgBA;EACE,cHhLS;EGiLT,qBEXwC;EFYxC,6BAAA;ALbF;AQnKE;EHmLE,cEdsC;EFetC,0BEdsC;APC1C;;AKsBA;EACE,cAAA;EACA,qBAAA;ALnBF;AQ5KE;EHkME,cAAA;EACA,qBAAA;ALnBJ;;AK4BA;;;;EAIE,iGE0D4B;EDlH1B,cAAA;ANgCJ;;AK4BA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AL9BF;;AKsCA;EAEE,gBAAA;ALpCF;;AK4CA;EACE,sBAAA;EACA,kBAAA;ALzCF;;AK4CA;EAGE,gBAAA;EACA,sBAAA;AL3CF;;AKmDA;EACE,yBAAA;ALhDF;;AKmDA;EACE,oBE8E4B;EF7E5B,uBE6E4B;EF5E5B,cEtQS;EFuQT,gBAAA;EACA,oBAAA;ALhDF;;AKuDA;EAEE,mBAAA;EACA,gCAAA;ALrDF;;AK6DA;EAEE,qBAAA;EACA,qBE4JsC;APvNxC;;AKiEA;EAEE,gBAAA;AL/DF;;AKuEA;EACE,UAAA;ALpEF;;AKuEA;;;;;EAKE,SAAA;EACA,oBAAA;EChKE,kBAAA;EDkKF,oBAAA;ALpEF;;AKuEA;;EAEE,iBAAA;ALpEF;;AKuEA;;EAEE,oBAAA;ALpEF;;AK0EA;EACE,eAAA;ALvEF;;AK6EA;EACE,iBAAA;AL1EF;;AKiFA;;;;EAIE,0BAAA;AL9EF;;AKuFI;;;;EACE,eAAA;ALjFN;;AKuFA;;;;EAIE,UAAA;EACA,kBAAA;ALpFF;;AKuFA;;EAEE,sBAAA;EACA,UAAA;ALpFF;;AKwFA;EACE,cAAA;EAEA,gBAAA;ALtFF;;AKyFA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AL5FF;;AKiGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EC9OI,iBAAA;EDgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AL9FF;;AKiGA;EACE,wBAAA;AL9FF;;AKkGA;;EAEE,YAAA;AL/FF;;AKkGA;EAKE,oBAAA;EACA,wBAAA;ALnGF;;AK0GA;EACE,wBAAA;ALvGF;;AK+GA;EACE,aAAA;EACA,0BAAA;AL5GF;;AKmHA;EACE,qBAAA;ALhHF;;AKmHA;EACE,kBAAA;EACA,eAAA;ALhHF;;AKmHA;EACE,aAAA;ALhHF;;AKqHA;EACE,wBAAA;ALlHF;;AS1WA;;EAEE,qBFsS4B;EEpS5B,iBPoGqB;EOnGrB,gBFsS4B;EErS5B,cPCc;AF2WhB;;ASzWA;EHqKM,iBAAA;ANwMN;;AS5WA;EHoKM,eAAA;AN4MN;;AS/WA;EHmKM,kBAAA;ANgNN;;ASlXA;EHkKM,iBAAA;ANoNN;;ASrXA;EHiKM,kBAAA;ANwNN;;ASxXA;EHgKM,eAAA;AN4NN;;AS1XA;EH8JM,kBAAA;EG5JJ,gBFwS4B;APqF9B;;ASzXA;EHwJM,eAAA;EGtJJ,gBF2R4B;EE1R5B,gBFkR4B;AP0G9B;;AS1XA;EHmJM,iBAAA;EGjJJ,gBFuR4B;EEtR5B,gBF6Q4B;APgH9B;;AS3XA;EH8IM,iBAAA;EG5IJ,gBFmR4B;EElR5B,gBFwQ4B;APsH9B;;AS5XA;EHyIM,iBAAA;EGvIJ,gBF+Q4B;EE9Q5B,gBFmQ4B;AP4H9B;;ASvXA;EACE,gBFgFO;EE/EP,mBF+EO;EE9EP,SAAA;EACA,wCAAA;AT0XF;;ASlXA;;EHkGI,kBAAA;EG/FF,gBF2N4B;AP0J9B;;ASlXA;;EAEE,cFmQ4B;EElQ5B,yBF2Q4B;AP0G9B;;AS7WA;EC/EE,eAAA;EACA,gBAAA;AVgcF;;AS7WA;ECpFE,eAAA;EACA,gBAAA;AVqcF;;AS/WA;EACE,qBAAA;ATkXF;AShXE;EACE,oBFqP0B;AP6H9B;;ASxWA;EH2DI,cAAA;EGzDF,yBAAA;AT2WF;;ASvWA;EACE,mBFuBO;ED6CH,kBAAA;ANuSN;;ASvWA;EACE,cAAA;EH+CE,kBAAA;EG7CF,cF1GS;APodX;ASxWE;EACE,aAAA;AT0WJ;;AW7dA;ECIE,eAAA;EAGA,YAAA;AZ2dF;;AW5dA;EACE,gBJqgCkC;EIpgClC,yBAAA;EACA,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AZoeF;;AWtdA;EAEE,qBAAA;AXwdF;;AWrdA;EACE,qBAAA;EACA,cAAA;AXwdF;;AWrdA;EL8HI,cAAA;EK5HF,cJ3BS;APmfX;;Ac/fA;ERmKI,gBAAA;EQjKF,cPmCQ;EOlCR,qBAAA;AdkgBF;Ac/fE;EACE,cAAA;AdigBJ;;Ac5fA;EACE,sBAAA;ERsJE,gBAAA;EQpJF,WPTS;EOUT,yBPDS;EMEP,qBAAA;Ab+fJ;Ac5fE;EACE,UAAA;ER8IA,eAAA;EQ5IA,gBPyQ0B;APqP9B;;AcxfA;EACE,cAAA;ERqIE,gBAAA;EQnIF,cPjBS;AP4gBX;AcxfE;ERgIE,kBAAA;EQ9HA,cAAA;EACA,kBAAA;Ad0fJ;;AcrfA;EACE,iBPikCkC;EOhkClC,kBAAA;AdwfF;;AehiBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AhB0iBF;;AiBvfI;EFzCE;IACE,gBR8Le;EPsWrB;AACF;AiB7fI;EFzCE;IACE,gBR8Le;EP2WrB;AACF;AiBlgBI;EFzCE;IACE,gBR8Le;EPgXrB;AACF;AiBvgBI;EFzCE;IACE,iBR8Le;EPqXrB;AACF;AexhBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhB8jBF;;AexhBE;EACE,eAAA;EACA,cAAA;Af2hBJ;AezhBI;;EAEE,gBAAA;EACA,eAAA;Af2hBN;;AkBjlBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AlBylBJ;;AkBnkBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AlBskBR;;AgB1iBE;EACE,cAAA;EACA,eAAA;AhB6iBJ;;AgB/iBE;EACE,aAAA;EACA,cAAA;AhBkjBJ;;AgBpjBE;EACE,wBAAA;EACA,yBAAA;AhBujBJ;;AgBzjBE;EACE,aAAA;EACA,cAAA;AhB4jBJ;;AgB9jBE;EACE,aAAA;EACA,cAAA;AhBikBJ;;AgBnkBE;EACE,wBAAA;EACA,yBAAA;AhBskBJ;;AkBzlBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AhB4lBF;;AkBzlBU;EFbR,qBAAA;EAIA,sBAAA;AhBumBF;;AkB9lBU;EFbR,sBAAA;EAIA,uBAAA;AhB4mBF;;AkBnmBU;EFbR,aAAA;EAIA,cAAA;AhBinBF;;AkBxmBU;EFbR,sBAAA;EAIA,uBAAA;AhBsnBF;;AkB7mBU;EFbR,sBAAA;EAIA,uBAAA;AhB2nBF;;AkBlnBU;EFbR,aAAA;EAIA,cAAA;AhBgoBF;;AkBvnBU;EFbR,sBAAA;EAIA,uBAAA;AhBqoBF;;AkB5nBU;EFbR,sBAAA;EAIA,uBAAA;AhB0oBF;;AkBjoBU;EFbR,aAAA;EAIA,cAAA;AhB+oBF;;AkBtoBU;EFbR,sBAAA;EAIA,uBAAA;AhBopBF;;AkB3oBU;EFbR,sBAAA;EAIA,uBAAA;AhBypBF;;AkBhpBU;EFbR,cAAA;EAIA,eAAA;AhB8pBF;;AkB/oBM;EAAwB,SAAA;AlBmpB9B;;AkBjpBM;EAAuB,SAAA;AlBqpB7B;;AkBlpBQ;EAAwB,QADb;AlBupBnB;;AkBtpBQ;EAAwB,QADb;AlB2pBnB;;AkB1pBQ;EAAwB,QADb;AlB+pBnB;;AkB9pBQ;EAAwB,QADb;AlBmqBnB;;AkBlqBQ;EAAwB,QADb;AlBuqBnB;;AkBtqBQ;EAAwB,QADb;AlB2qBnB;;AkB1qBQ;EAAwB,QADb;AlB+qBnB;;AkB9qBQ;EAAwB,QADb;AlBmrBnB;;AkBlrBQ;EAAwB,QADb;AlBurBnB;;AkBtrBQ;EAAwB,QADb;AlB2rBnB;;AkB1rBQ;EAAwB,SADb;AlB+rBnB;;AkB9rBQ;EAAwB,SADb;AlBmsBnB;;AkBlsBQ;EAAwB,SADb;AlBusBnB;;AkB/rBY;EFhBV,wBAAA;AhBmtBF;;AkBnsBY;EFhBV,yBAAA;AhButBF;;AkBvsBY;EFhBV,gBAAA;AhB2tBF;;AkB3sBY;EFhBV,yBAAA;AhB+tBF;;AkB/sBY;EFhBV,yBAAA;AhBmuBF;;AkBntBY;EFhBV,gBAAA;AhBuuBF;;AkBvtBY;EFhBV,yBAAA;AhB2uBF;;AkB3tBY;EFhBV,yBAAA;AhB+uBF;;AkB/tBY;EFhBV,gBAAA;AhBmvBF;;AkBnuBY;EFhBV,yBAAA;AhBuvBF;;AkBvuBY;EFhBV,yBAAA;AhB2vBF;;AiBtvBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBqxBN;EgBzvBA;IACE,cAAA;IACA,eAAA;EhB2vBF;EgB7vBA;IACE,aAAA;IACA,cAAA;EhB+vBF;EgBjwBA;IACE,wBAAA;IACA,yBAAA;EhBmwBF;EgBrwBA;IACE,aAAA;IACA,cAAA;EhBuwBF;EgBzwBA;IACE,aAAA;IACA,cAAA;EhB2wBF;EgB7wBA;IACE,wBAAA;IACA,yBAAA;EhB+wBF;EkBlyBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBoyBA;EkBjyBQ;IFbR,qBAAA;IAIA,sBAAA;EhB8yBA;EkBryBQ;IFbR,sBAAA;IAIA,uBAAA;EhBkzBA;EkBzyBQ;IFbR,aAAA;IAIA,cAAA;EhBszBA;EkB7yBQ;IFbR,sBAAA;IAIA,uBAAA;EhB0zBA;EkBjzBQ;IFbR,sBAAA;IAIA,uBAAA;EhB8zBA;EkBrzBQ;IFbR,aAAA;IAIA,cAAA;EhBk0BA;EkBzzBQ;IFbR,sBAAA;IAIA,uBAAA;EhBs0BA;EkB7zBQ;IFbR,sBAAA;IAIA,uBAAA;EhB00BA;EkBj0BQ;IFbR,aAAA;IAIA,cAAA;EhB80BA;EkBr0BQ;IFbR,sBAAA;IAIA,uBAAA;EhBk1BA;EkBz0BQ;IFbR,sBAAA;IAIA,uBAAA;EhBs1BA;EkB70BQ;IFbR,cAAA;IAIA,eAAA;EhB01BA;EkB30BI;IAAwB,SAAA;ElB80B5B;EkB50BI;IAAuB,SAAA;ElB+0B3B;EkB50BM;IAAwB,QADb;ElBg1BjB;EkB/0BM;IAAwB,QADb;ElBm1BjB;EkBl1BM;IAAwB,QADb;ElBs1BjB;EkBr1BM;IAAwB,QADb;ElBy1BjB;EkBx1BM;IAAwB,QADb;ElB41BjB;EkB31BM;IAAwB,QADb;ElB+1BjB;EkB91BM;IAAwB,QADb;ElBk2BjB;EkBj2BM;IAAwB,QADb;ElBq2BjB;EkBp2BM;IAAwB,QADb;ElBw2BjB;EkBv2BM;IAAwB,QADb;ElB22BjB;EkB12BM;IAAwB,SADb;ElB82BjB;EkB72BM;IAAwB,SADb;ElBi3BjB;EkBh3BM;IAAwB,SADb;ElBo3BjB;EkB52BU;IFhBV,cAAA;EhB+3BA;EkB/2BU;IFhBV,wBAAA;EhBk4BA;EkBl3BU;IFhBV,yBAAA;EhBq4BA;EkBr3BU;IFhBV,gBAAA;EhBw4BA;EkBx3BU;IFhBV,yBAAA;EhB24BA;EkB33BU;IFhBV,yBAAA;EhB84BA;EkB93BU;IFhBV,gBAAA;EhBi5BA;EkBj4BU;IFhBV,yBAAA;EhBo5BA;EkBp4BU;IFhBV,yBAAA;EhBu5BA;EkBv4BU;IFhBV,gBAAA;EhB05BA;EkB14BU;IFhBV,yBAAA;EhB65BA;EkB74BU;IFhBV,yBAAA;EhBg6BA;AACF;AiB55BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB07BN;EgB95BA;IACE,cAAA;IACA,eAAA;EhBg6BF;EgBl6BA;IACE,aAAA;IACA,cAAA;EhBo6BF;EgBt6BA;IACE,wBAAA;IACA,yBAAA;EhBw6BF;EgB16BA;IACE,aAAA;IACA,cAAA;EhB46BF;EgB96BA;IACE,aAAA;IACA,cAAA;EhBg7BF;EgBl7BA;IACE,wBAAA;IACA,yBAAA;EhBo7BF;EkBv8BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBy8BA;EkBt8BQ;IFbR,qBAAA;IAIA,sBAAA;EhBm9BA;EkB18BQ;IFbR,sBAAA;IAIA,uBAAA;EhBu9BA;EkB98BQ;IFbR,aAAA;IAIA,cAAA;EhB29BA;EkBl9BQ;IFbR,sBAAA;IAIA,uBAAA;EhB+9BA;EkBt9BQ;IFbR,sBAAA;IAIA,uBAAA;EhBm+BA;EkB19BQ;IFbR,aAAA;IAIA,cAAA;EhBu+BA;EkB99BQ;IFbR,sBAAA;IAIA,uBAAA;EhB2+BA;EkBl+BQ;IFbR,sBAAA;IAIA,uBAAA;EhB++BA;EkBt+BQ;IFbR,aAAA;IAIA,cAAA;EhBm/BA;EkB1+BQ;IFbR,sBAAA;IAIA,uBAAA;EhBu/BA;EkB9+BQ;IFbR,sBAAA;IAIA,uBAAA;EhB2/BA;EkBl/BQ;IFbR,cAAA;IAIA,eAAA;EhB+/BA;EkBh/BI;IAAwB,SAAA;ElBm/B5B;EkBj/BI;IAAuB,SAAA;ElBo/B3B;EkBj/BM;IAAwB,QADb;ElBq/BjB;EkBp/BM;IAAwB,QADb;ElBw/BjB;EkBv/BM;IAAwB,QADb;ElB2/BjB;EkB1/BM;IAAwB,QADb;ElB8/BjB;EkB7/BM;IAAwB,QADb;ElBigCjB;EkBhgCM;IAAwB,QADb;ElBogCjB;EkBngCM;IAAwB,QADb;ElBugCjB;EkBtgCM;IAAwB,QADb;ElB0gCjB;EkBzgCM;IAAwB,QADb;ElB6gCjB;EkB5gCM;IAAwB,QADb;ElBghCjB;EkB/gCM;IAAwB,SADb;ElBmhCjB;EkBlhCM;IAAwB,SADb;ElBshCjB;EkBrhCM;IAAwB,SADb;ElByhCjB;EkBjhCU;IFhBV,cAAA;EhBoiCA;EkBphCU;IFhBV,wBAAA;EhBuiCA;EkBvhCU;IFhBV,yBAAA;EhB0iCA;EkB1hCU;IFhBV,gBAAA;EhB6iCA;EkB7hCU;IFhBV,yBAAA;EhBgjCA;EkBhiCU;IFhBV,yBAAA;EhBmjCA;EkBniCU;IFhBV,gBAAA;EhBsjCA;EkBtiCU;IFhBV,yBAAA;EhByjCA;EkBziCU;IFhBV,yBAAA;EhB4jCA;EkB5iCU;IFhBV,gBAAA;EhB+jCA;EkB/iCU;IFhBV,yBAAA;EhBkkCA;EkBljCU;IFhBV,yBAAA;EhBqkCA;AACF;AiBjkCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB+lCN;EgBnkCA;IACE,cAAA;IACA,eAAA;EhBqkCF;EgBvkCA;IACE,aAAA;IACA,cAAA;EhBykCF;EgB3kCA;IACE,wBAAA;IACA,yBAAA;EhB6kCF;EgB/kCA;IACE,aAAA;IACA,cAAA;EhBilCF;EgBnlCA;IACE,aAAA;IACA,cAAA;EhBqlCF;EgBvlCA;IACE,wBAAA;IACA,yBAAA;EhBylCF;EkB5mCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhB8mCA;EkB3mCQ;IFbR,qBAAA;IAIA,sBAAA;EhBwnCA;EkB/mCQ;IFbR,sBAAA;IAIA,uBAAA;EhB4nCA;EkBnnCQ;IFbR,aAAA;IAIA,cAAA;EhBgoCA;EkBvnCQ;IFbR,sBAAA;IAIA,uBAAA;EhBooCA;EkB3nCQ;IFbR,sBAAA;IAIA,uBAAA;EhBwoCA;EkB/nCQ;IFbR,aAAA;IAIA,cAAA;EhB4oCA;EkBnoCQ;IFbR,sBAAA;IAIA,uBAAA;EhBgpCA;EkBvoCQ;IFbR,sBAAA;IAIA,uBAAA;EhBopCA;EkB3oCQ;IFbR,aAAA;IAIA,cAAA;EhBwpCA;EkB/oCQ;IFbR,sBAAA;IAIA,uBAAA;EhB4pCA;EkBnpCQ;IFbR,sBAAA;IAIA,uBAAA;EhBgqCA;EkBvpCQ;IFbR,cAAA;IAIA,eAAA;EhBoqCA;EkBrpCI;IAAwB,SAAA;ElBwpC5B;EkBtpCI;IAAuB,SAAA;ElBypC3B;EkBtpCM;IAAwB,QADb;ElB0pCjB;EkBzpCM;IAAwB,QADb;ElB6pCjB;EkB5pCM;IAAwB,QADb;ElBgqCjB;EkB/pCM;IAAwB,QADb;ElBmqCjB;EkBlqCM;IAAwB,QADb;ElBsqCjB;EkBrqCM;IAAwB,QADb;ElByqCjB;EkBxqCM;IAAwB,QADb;ElB4qCjB;EkB3qCM;IAAwB,QADb;ElB+qCjB;EkB9qCM;IAAwB,QADb;ElBkrCjB;EkBjrCM;IAAwB,QADb;ElBqrCjB;EkBprCM;IAAwB,SADb;ElBwrCjB;EkBvrCM;IAAwB,SADb;ElB2rCjB;EkB1rCM;IAAwB,SADb;ElB8rCjB;EkBtrCU;IFhBV,cAAA;EhBysCA;EkBzrCU;IFhBV,wBAAA;EhB4sCA;EkB5rCU;IFhBV,yBAAA;EhB+sCA;EkB/rCU;IFhBV,gBAAA;EhBktCA;EkBlsCU;IFhBV,yBAAA;EhBqtCA;EkBrsCU;IFhBV,yBAAA;EhBwtCA;EkBxsCU;IFhBV,gBAAA;EhB2tCA;EkB3sCU;IFhBV,yBAAA;EhB8tCA;EkB9sCU;IFhBV,yBAAA;EhBiuCA;EkBjtCU;IFhBV,gBAAA;EhBouCA;EkBptCU;IFhBV,yBAAA;EhBuuCA;EkBvtCU;IFhBV,yBAAA;EhB0uCA;AACF;AiBtuCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBowCN;EgBxuCA;IACE,cAAA;IACA,eAAA;EhB0uCF;EgB5uCA;IACE,aAAA;IACA,cAAA;EhB8uCF;EgBhvCA;IACE,wBAAA;IACA,yBAAA;EhBkvCF;EgBpvCA;IACE,aAAA;IACA,cAAA;EhBsvCF;EgBxvCA;IACE,aAAA;IACA,cAAA;EhB0vCF;EgB5vCA;IACE,wBAAA;IACA,yBAAA;EhB8vCF;EkBjxCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBmxCA;EkBhxCQ;IFbR,qBAAA;IAIA,sBAAA;EhB6xCA;EkBpxCQ;IFbR,sBAAA;IAIA,uBAAA;EhBiyCA;EkBxxCQ;IFbR,aAAA;IAIA,cAAA;EhBqyCA;EkB5xCQ;IFbR,sBAAA;IAIA,uBAAA;EhByyCA;EkBhyCQ;IFbR,sBAAA;IAIA,uBAAA;EhB6yCA;EkBpyCQ;IFbR,aAAA;IAIA,cAAA;EhBizCA;EkBxyCQ;IFbR,sBAAA;IAIA,uBAAA;EhBqzCA;EkB5yCQ;IFbR,sBAAA;IAIA,uBAAA;EhByzCA;EkBhzCQ;IFbR,aAAA;IAIA,cAAA;EhB6zCA;EkBpzCQ;IFbR,sBAAA;IAIA,uBAAA;EhBi0CA;EkBxzCQ;IFbR,sBAAA;IAIA,uBAAA;EhBq0CA;EkB5zCQ;IFbR,cAAA;IAIA,eAAA;EhBy0CA;EkB1zCI;IAAwB,SAAA;ElB6zC5B;EkB3zCI;IAAuB,SAAA;ElB8zC3B;EkB3zCM;IAAwB,QADb;ElB+zCjB;EkB9zCM;IAAwB,QADb;ElBk0CjB;EkBj0CM;IAAwB,QADb;ElBq0CjB;EkBp0CM;IAAwB,QADb;ElBw0CjB;EkBv0CM;IAAwB,QADb;ElB20CjB;EkB10CM;IAAwB,QADb;ElB80CjB;EkB70CM;IAAwB,QADb;ElBi1CjB;EkBh1CM;IAAwB,QADb;ElBo1CjB;EkBn1CM;IAAwB,QADb;ElBu1CjB;EkBt1CM;IAAwB,QADb;ElB01CjB;EkBz1CM;IAAwB,SADb;ElB61CjB;EkB51CM;IAAwB,SADb;ElBg2CjB;EkB/1CM;IAAwB,SADb;ElBm2CjB;EkB31CU;IFhBV,cAAA;EhB82CA;EkB91CU;IFhBV,wBAAA;EhBi3CA;EkBj2CU;IFhBV,yBAAA;EhBo3CA;EkBp2CU;IFhBV,gBAAA;EhBu3CA;EkBv2CU;IFhBV,yBAAA;EhB03CA;EkB12CU;IFhBV,yBAAA;EhB63CA;EkB72CU;IFhBV,gBAAA;EhBg4CA;EkBh3CU;IFhBV,yBAAA;EhBm4CA;EkBn3CU;IFhBV,yBAAA;EhBs4CA;EkBt3CU;IFhBV,gBAAA;EhBy4CA;EkBz3CU;IFhBV,yBAAA;EhB44CA;EkB53CU;IFhBV,yBAAA;EhB+4CA;AACF;AmBn8CA;EACE,WAAA;EACA,mBZiIO;EYhIP,cjBMc;EiBLd,sBjBJU;AFy8CZ;AmBn8CE;;EAEE,gBZmV0B;EYlV1B,mBAAA;EACA,6BAAA;AnBq8CJ;AmBl8CE;EACE,sBAAA;EACA,gCAAA;AnBo8CJ;AmBj8CE;EACE,6BAAA;AnBm8CJ;;AmBz7CE;;EAEE,eZ6T0B;AP+nC9B;;AmBn7CA;EACE,yBAAA;AnBs7CF;AmBp7CE;;EAEE,yBAAA;AnBs7CJ;AmBl7CI;;EAEE,wBAAA;AnBo7CN;;AmB96CE;;;;EAIE,SAAA;AnBi7CJ;;AmBx6CE;EACE,yBjB5Da;AFu+CjB;;AQ1+CE;EW2EI,cjB1EU;EiB2EV,wCjBoDW;AF+2CjB;;AoBr/CI;;;EAGE,yBD2F+B;AnB65CrC;AoBp/CM;;;;EAIE,qBDmFyE;AnBm6CjF;;AQ3/CE;EYiBM,yBAJe;ApBk/CvB;AoB5+CQ;;EAEE,yBARa;ApBs/CvB;;AoBzgDI;;;EAGE,yBD2F+B;AnBi7CrC;AoBxgDM;;;;EAIE,qBDmFyE;AnBu7CjF;;AQ/gDE;EYiBM,yBAJe;ApBsgDvB;AoBhgDQ;;EAEE,yBARa;ApB0gDvB;;AoB7hDI;;;EAGE,yBD2F+B;AnBq8CrC;AoB5hDM;;;;EAIE,qBDmFyE;AnB28CjF;;AQniDE;EYiBM,yBAJe;ApB0hDvB;AoBphDQ;;EAEE,yBARa;ApB8hDvB;;AoBjjDI;;;EAGE,yBD2F+B;AnBy9CrC;AoBhjDM;;;;EAIE,qBDmFyE;AnB+9CjF;;AQvjDE;EYiBM,yBAJe;ApB8iDvB;AoBxiDQ;;EAEE,yBARa;ApBkjDvB;;AoBrkDI;;;EAGE,yBD2F+B;AnB6+CrC;AoBpkDM;;;;EAIE,qBDmFyE;AnBm/CjF;;AQ3kDE;EYiBM,yBAJe;ApBkkDvB;AoB5jDQ;;EAEE,yBARa;ApBskDvB;;AoBzlDI;;;EAGE,yBD2F+B;AnBigDrC;AoBxlDM;;;;EAIE,qBDmFyE;AnBugDjF;;AQ/lDE;EYiBM,yBAJe;ApBslDvB;AoBhlDQ;;EAEE,yBARa;ApB0lDvB;;AoB7mDI;;;EAGE,yBD2F+B;AnBqhDrC;AoB5mDM;;;;EAIE,qBDmFyE;AnB2hDjF;;AQnnDE;EYiBM,yBAJe;ApB0mDvB;AoBpmDQ;;EAEE,yBARa;ApB8mDvB;;AoBjoDI;;;EAGE,yBD2F+B;AnByiDrC;AoBhoDM;;;;EAIE,qBDmFyE;AnB+iDjF;;AQvoDE;EYiBM,yBAJe;ApB8nDvB;AoBxnDQ;;EAEE,yBARa;ApBkoDvB;;AoBrpDI;;;EAGE,wClBoIa;AFohDnB;;AQrpDE;EYiBM,wCAJe;ApB4oDvB;AoBtoDQ;;EAEE,wCARa;ApBgpDvB;;AmBxjDI;EACE,WZ3GK;EY4GL,yBZpGK;EYqGL,qBZiQwB;AP0zC9B;AmBtjDI;EACE,cZ5GK;EY6GL,yBZlHK;EYmHL,qBZlHK;AP0qDX;;AmBnjDA;EACE,WZ3HS;EY4HT,yBZpHS;AP0qDX;AmBpjDE;;;EAGE,qBZ6O0B;APy0C9B;AmBnjDE;EACE,SAAA;AnBqjDJ;AmBjjDI;EACE,2CZiOwB;APk1C9B;AQxrDE;EW4IM,WZjJG;EYkJH,4CZ2NsB;APo1C9B;;AiB/nDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBiiDN;EmB9hDM;IACE,SAAA;EnBgiDR;AACF;AiB3oDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnB4iDN;EmBziDM;IACE,SAAA;EnB2iDR;AACF;AiBtpDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBujDN;EmBpjDM;IACE,SAAA;EnBsjDR;AACF;AiBjqDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBkkDN;EmB/jDM;IACE,SAAA;EnBikDR;AACF;AmB3kDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AnB4kDR;AmBzkDQ;EACE,SAAA;AnB2kDV;;AqBxvDA;EACE,cAAA;EACA,WAAA;EACA,mCd2esC;Ec1etC,yBAAA;Ef0KI,eAAA;EevKJ,gBdmR4B;EclR5B,gBduR4B;EctR5B,cdDS;EcET,sBdTS;EcUT,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;ArBsvDF;AsB1vDM;EDdN;ICeQ,gBAAA;EtB6vDN;AACF;AqBxvDE;EACE,6BAAA;EACA,SAAA;ArB0vDJ;AuB1wDE;EACE,cAAA;EACA,sBhBRO;EgBSP,qBhBsdoC;EgBrdpC,UAAA;EAKE,gBrByCuB;AF+tD7B;AqB1vDE;EACE,cdxBO;Ec0BP,UAAA;ArB2vDJ;AqBnvDE;EAEE,yBdxCO;Ec0CP,UAAA;ArBmvDJ;;AqB3uDE;;;;EACE,wBAAA;UAAA,gBAAA;ArBivDJ;;AqB3uDE;EACE,kBAAA;EACA,0BAAA;ArB8uDJ;AqB3uDE;EAME,cd/DO;EcgEP,sBdvEO;AP+yDX;;AqBnuDA;;EAEE,cAAA;EACA,WAAA;ArBsuDF;;AqB5tDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EfiEE,kBAAA;Ee/DF,gBdgM4B;AP+hD9B;;AqB5tDA;EACE,+BAAA;EACA,kCAAA;Ef0EI,kBAAA;EexEJ,gBd6H4B;APkmD9B;;AqB5tDA;EACE,gCAAA;EACA,mCAAA;EfmEI,mBAAA;EejEJ,gBduH4B;APwmD9B;;AqBttDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EfoDI,eAAA;EelDJ,gBdmK4B;EclK5B,cnBtHc;EmBuHd,6BAAA;EACA,yBAAA;EACA,mBAAA;ArBytDF;AqBvtDE;EAEE,gBAAA;EACA,eAAA;ArBwtDJ;;AqB5sDA;EACE,kCd6VsC;Ec5VtC,uBAAA;Ef2BI,mBAAA;EezBJ,gBd+E4B;EMxN1B,qBAAA;Aby1DJ;;AqB5sDA;EACE,gCdsVsC;EcrVtC,oBAAA;EfmBI,kBAAA;EejBJ,gBdsE4B;EMvN1B,qBAAA;Abi2DJ;;AqB1sDE;EAEE,YAAA;ArB4sDJ;;AqBxsDA;EACE,YAAA;ArB2sDF;;AqBnsDA;EACE,mBd2UsC;AP23CxC;;AqBnsDA;EACE,cAAA;EACA,mBd4TsC;AP04CxC;;AqB9rDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ArBisDF;AqB/rDE;;EAEE,kBAAA;EACA,iBAAA;ArBisDJ;;AqBxrDA;EACE,kBAAA;EACA,cAAA;EACA,qBdiSsC;AP05CxC;;AqBxrDA;EACE,kBAAA;EACA,kBd6RsC;Ec5RtC,qBAAA;ArB2rDF;AqBxrDE;EAEE,cdzNO;APk5DX;;AqBrrDA;EACE,gBAAA;ArBwrDF;;AqBrrDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBd8QsC;AP06CxC;AqBrrDE;EACE,gBAAA;EACA,aAAA;EACA,uBdyQoC;EcxQpC,cAAA;ArBurDJ;;AuBp4DE;EACE,aAAA;EACA,WAAA;EACA,mBhB2coC;EDtVpC,kBAAA;EiBnHA,cFqNqC;ArBkrDzC;;AuBp4DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,mBAAA;EiBtHF,gBhBuO0B;EgBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;Abs7DJ;AuBn4DI;EAEE,SAAA;AvBo4DN;;AuB/3DI;;;;EAEE,cAAA;AvBo4DN;;AuBl7DI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,iRAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AvBg4DR;AuB73DM;EACE,qBFuKiC;EEtKjC,gDAAA;AvB+3DR;;AuB/7DI;EAyEI,8BAAA;EACA,wCAAA;AvB03DR;;AuBp8DI;EAmFI,oChB6XgC;EgB5XhC,kFAAA;AvBq3DR;;AuBz8DI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,ujBAAA;AvBg3DR;AuB72DM;EACE,qBFmIiC;EElIjC,gDAAA;AvB+2DR;;AuBx2DM;EACE,cF0HiC;ArBivDzC;AuBx2DM;;;EAEE,cAAA;AvB22DR;;AuBp2DM;EACE,cF6GiC;ArB0vDzC;AuBr2DQ;EACE,qBF0G+B;ArB6vDzC;AuBl2DQ;EACE,qBAAA;EC5JN,yBD6J2B;AvBo2D/B;AuB/1DQ;EACE,gDAAA;AvBi2DV;AuB91DQ;EACE,qBFyF+B;ArBuwDzC;;AuBv1DM;EACE,qBF+EiC;ArB2wDzC;AuBt1DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AvBw1DV;;AuBz+DE;EACE,aAAA;EACA,WAAA;EACA,mBhB2coC;EDtVpC,kBAAA;EiBnHA,cFqNqC;ArBuxDzC;;AuBz+DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,mBAAA;EiBtHF,gBhBuO0B;EgBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;Ab2hEJ;AuBx+DI;EAEE,SAAA;AvBy+DN;;AuBp+DI;;;;EAEE,cAAA;AvBy+DN;;AuBvhEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,4UAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AvBq+DR;AuBl+DM;EACE,qBFuKiC;EEtKjC,gDAAA;AvBo+DR;;AuBpiEI;EAyEI,8BAAA;EACA,wCAAA;AvB+9DR;;AuBziEI;EAmFI,oChB6XgC;EgB5XhC,kFAAA;AvB09DR;;AuB9iEI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,knBAAA;AvBq9DR;AuBl9DM;EACE,qBFmIiC;EElIjC,gDAAA;AvBo9DR;;AuB78DM;EACE,cF0HiC;ArBs1DzC;AuB78DM;;;EAEE,cAAA;AvBg9DR;;AuBz8DM;EACE,cF6GiC;ArB+1DzC;AuB18DQ;EACE,qBF0G+B;ArBk2DzC;AuBv8DQ;EACE,qBAAA;EC5JN,yBD6J2B;AvBy8D/B;AuBp8DQ;EACE,gDAAA;AvBs8DV;AuBn8DQ;EACE,qBFyF+B;ArB42DzC;;AuB57DM;EACE,qBF+EiC;ArBg3DzC;AuB37DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AvB67DV;;AqBx2DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ArB22DF;AqBt2DE;EACE,WAAA;ArBw2DJ;AiBvkEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ErBs2DJ;EqBl2DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ErBo2DJ;EqBh2DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ErBk2DJ;EqB91DE;IACE,qBAAA;ErBg2DJ;EqB71DE;;IAEE,WAAA;ErB+1DJ;EqB11DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ErB41DJ;EqB11DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBdgLkC;Ic/KlC,cAAA;ErB41DJ;EqBz1DE;IACE,mBAAA;IACA,uBAAA;ErB21DJ;EqBz1DE;IACE,gBAAA;ErB21DJ;AACF;;AyB7qEA;EACE,qBAAA;EAEA,gBlBuR4B;EkBtR5B,cvBGc;EuBFd,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EpB4EI,eAAA;EoB1EJ,gBnB2L4B;EMnR1B,sBAAA;ESFE,qIGGJ;AzBgrEF;AsB/qEM;EGdN;IHeQ,gBAAA;EtBkrEN;AACF;AQ5rEE;EiBUE,cvBTY;EuBUZ,qBAAA;AzBqrEJ;AyBlrEE;EAEE,UAAA;EACA,gBvBqCmB;AF8oEvB;AyB/qEE;EAEE,avB2BmB;AFqpEvB;AyB5qEE;EACE,eAAA;AzB8qEJ;AyBhqEA;;EAEE,oBAAA;AzBkqEF;;AyBzpEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APopEf;AQptEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1BguEzG;A0BptEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1BitEN;A0B5sEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APoqEf;A0BtsEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1BgvE7L;A0BjsEI;EAKI,gDAAA;A1B+rER;;AyBvrEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APkrEf;AQlvEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B8vEzG;A0BlvEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A1B+uEN;A0B1uEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APksEf;A0BpuEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B8wE7L;A0B/tEI;EAKI,iDAAA;A1B6tER;;AyBrtEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APgtEf;AQhxEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B4xEzG;A0BhxEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1B6wEN;A0BxwEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APguEf;A0BlwEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B4yE7L;A0B7vEI;EAKI,gDAAA;A1B2vER;;AyBnvEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP8uEf;AQ9yEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B0zEzG;A0B9yEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1B2yEN;A0BtyEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP8vEf;A0BhyEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B00E7L;A0B3xEI;EAKI,gDAAA;A1ByxER;;AyBjxEE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP4wEf;AQ50EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bw1EzG;A0B50EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1By0EN;A0Bp0EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP4xEf;A0B9zEE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bw2E7L;A0BzzEI;EAKI,gDAAA;A1BuzER;;AyB/yEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP0yEf;AQ12EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bs3EzG;A0B12EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;A1Bu2EN;A0Bl2EE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP0zEf;A0B51EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bs4E7L;A0Bv1EI;EAKI,+CAAA;A1Bq1ER;;AyB70EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APw0Ef;AQx4EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bo5EzG;A0Bx4EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A1Bq4EN;A0Bh4EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APw1Ef;A0B13EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bo6E7L;A0Br3EI;EAKI,iDAAA;A1Bm3ER;;AyB32EE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APs2Ef;AQt6EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bk7EzG;A0Bt6EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,8CAAA;A1Bm6EN;A0B95EE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APs3Ef;A0Bx5EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bk8E7L;A0Bn5EI;EAKI,8CAAA;A1Bi5ER;;AyBn4EE;ECPA,cnBYa;EmBXb,qBnBWa;APm4Ef;AQn8EE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APw4Ef;A0B34EE;EAEE,+CAAA;A1B44EJ;A0Bz4EE;EAEE,cnBJW;EmBKX,6BAAA;A1B04EJ;A0Bv4EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APo5Ef;A0Br4EI;EAKI,+CAAA;A1Bm4ER;;AyB55EE;ECPA,cnBYa;EmBXb,qBnBWa;AP45Ef;AQ59EE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APi6Ef;A0Bp6EE;EAEE,iDAAA;A1Bq6EJ;A0Bl6EE;EAEE,cnBJW;EmBKX,6BAAA;A1Bm6EJ;A0Bh6EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP66Ef;A0B95EI;EAKI,iDAAA;A1B45ER;;AyBr7EE;ECPA,cnBYa;EmBXb,qBnBWa;APq7Ef;AQr/EE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP07Ef;A0B77EE;EAEE,+CAAA;A1B87EJ;A0B37EE;EAEE,cnBJW;EmBKX,6BAAA;A1B47EJ;A0Bz7EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APs8Ef;A0Bv7EI;EAKI,+CAAA;A1Bq7ER;;AyB98EE;ECPA,cnBYa;EmBXb,qBnBWa;AP88Ef;AQ9gFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APm9Ef;A0Bt9EE;EAEE,+CAAA;A1Bu9EJ;A0Bp9EE;EAEE,cnBJW;EmBKX,6BAAA;A1Bq9EJ;A0Bl9EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP+9Ef;A0Bh9EI;EAKI,+CAAA;A1B88ER;;AyBv+EE;ECPA,cnBYa;EmBXb,qBnBWa;APu+Ef;AQviFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP4+Ef;A0B/+EE;EAEE,gDAAA;A1Bg/EJ;A0B7+EE;EAEE,cnBJW;EmBKX,6BAAA;A1B8+EJ;A0B3+EE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;APw/Ef;A0Bz+EI;EAKI,gDAAA;A1Bu+ER;;AyBhgFE;ECPA,cnBYa;EmBXb,qBnBWa;APggFf;AQhkFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APqgFf;A0BxgFE;EAEE,+CAAA;A1BygFJ;A0BtgFE;EAEE,cnBJW;EmBKX,6BAAA;A1BugFJ;A0BpgFE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APihFf;A0BlgFI;EAKI,+CAAA;A1BggFR;;AyBzhFE;ECPA,cnBYa;EmBXb,qBnBWa;APyhFf;AQzlFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP8hFf;A0BjiFE;EAEE,iDAAA;A1BkiFJ;A0B/hFE;EAEE,cnBJW;EmBKX,6BAAA;A1BgiFJ;A0B7hFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP0iFf;A0B3hFI;EAKI,iDAAA;A1ByhFR;;AyBljFE;ECPA,cnBYa;EmBXb,qBnBWa;APkjFf;AQlnFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APujFf;A0B1jFE;EAEE,8CAAA;A1B2jFJ;A0BxjFE;EAEE,cnBJW;EmBKX,6BAAA;A1ByjFJ;A0BtjFE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APmkFf;A0BpjFI;EAKI,8CAAA;A1BkjFR;;AyBhkFA;EACE,gBlB6M4B;EkB5M5B,cvB1ES;EuB2ET,qBlB2FwC;APw+E1C;AQ5oFE;EiB4EE,clByFsC;EkBxFtC,0BlByFsC;AP0+E1C;AyBhkFE;EAEE,0BlBoFsC;AP6+E1C;AyB9jFE;EAEE,clBtFO;EkBuFP,oBAAA;AzB+jFJ;;AyBpjFA;ECPE,oBAAA;EpB4EI,kBAAA;EoB1EJ,gBnB+H4B;EMvN1B,qBAAA;AbwpFJ;;AyBvjFA;ECXE,uBAAA;EpB4EI,mBAAA;EoB1EJ,gBnBgI4B;EMxN1B,qBAAA;Ab+pFJ;;AyBrjFA;EACE,cAAA;EACA,WAAA;AzBwjFF;AyBrjFE;EACE,kBlBwT0B;AP+vE9B;;AyB/iFE;;;EACE,WAAA;AzBojFJ;;A2B/rFA;ELgBM,gCKfJ;A3BksFF;AsB/qFM;EKpBN;ILqBQ,gBAAA;EtBkrFN;AACF;A2BrsFE;EACE,UAAA;A3BusFJ;;A2BlsFE;EACE,aAAA;A3BqsFJ;;A2BjsFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A3BosFF;AsBlsFM;EKNN;ILOQ,gBAAA;EtBqsFN;AACF;A2BvsFE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A3BysFJ;AsB5sFM;EKAJ;ILCM,gBAAA;EtB+sFN;AACF;;A4BpuFA;;;;EAIE,kBAAA;A5BuuFF;;A4BpuFA;EACE,mBAAA;A5BuuFF;A6BntFI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A7BsvFF;A6BjsFI;EACE,cAAA;A7BmsFN;;A4B7uFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,arBypBkC;EqBxpBlC,aAAA;EACA,WAAA;EACA,gBrBiuBkC;EqBhuBlC,iBAAA;EACA,oBAAA;EtB2JI,eAAA;EsBzJJ,c1Bdc;E0Bed,gBAAA;EACA,gBAAA;EACA,sBrBvBS;EqBwBT,4BAAA;EACA,qCAAA;EfdE,sBAAA;Ab+vFJ;;A4BxuFI;EACE,WAAA;EACA,OAAA;A5B2uFN;;A4BxuFI;EACE,QAAA;EACA,UAAA;A5B2uFN;;AiB/tFI;EWnBA;IACE,WAAA;IACA,OAAA;E5BsvFJ;E4BnvFE;IACE,QAAA;IACA,UAAA;E5BqvFJ;AACF;AiB1uFI;EWnBA;IACE,WAAA;IACA,OAAA;E5BgwFJ;E4B7vFE;IACE,QAAA;IACA,UAAA;E5B+vFJ;AACF;AiBpvFI;EWnBA;IACE,WAAA;IACA,OAAA;E5B0wFJ;E4BvwFE;IACE,QAAA;IACA,UAAA;E5BywFJ;AACF;AiB9vFI;EWnBA;IACE,WAAA;IACA,OAAA;E5BoxFJ;E4BjxFE;IACE,QAAA;IACA,UAAA;E5BmxFJ;AACF;A4B5wFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBrB+rBgC;AP+kEpC;A6B7yFI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A7By0FF;A6B3xFI;EACE,cAAA;A7B6xFN;;A4BlxFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBrBirBgC;APomEpC;A6Bl0FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A7Bu1FF;A6BhzFI;EACE,cAAA;A7BkzFN;A4B7xFI;EACE,iBAAA;A5B+xFN;;A4BzxFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBrBgqBgC;AP4nEpC;A6B11FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;A7B41FN;A6Bj1FM;EACE,aAAA;A7Bm1FR;A6Bh1FM;EACE,qBAAA;EACA,qBtB4MsB;EsB3MtB,uBtB0MsB;EsBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A7Bi3FF;A6Bh1FI;EACE,cAAA;A7Bk1FN;A4B5yFI;EACE,iBAAA;A5B8yFN;;A4BtyFE;EAIE,WAAA;EACA,YAAA;A5BsyFJ;;A4BjyFA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A9Bm5FF;;A4BjyFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBrBiK4B;EqBhK5B,crBhHS;EqBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A5BmyFF;AQx5FE;EoBoIE,crBonBgC;EqBnnBhC,qBAAA;EJ/IA,yBjBGO;APo6FX;A4BpxFE;EAEE,WrBpJO;EqBqJP,qBAAA;EJtJA,yBjBoP0B;APwrF9B;A4BlxFE;EAEE,crBtJO;EqBuJP,oBAAA;EACA,6BAAA;A5BmxFJ;;A4B3wFA;EACE,cAAA;A5B8wFF;;A4B1wFA;EACE,cAAA;EACA,sBrBimBkC;EqBhmBlC,gBAAA;EtBAI,mBAAA;EsBEJ,crBzKS;EqB0KT,mBAAA;A5B6wFF;;A4BzwFA;EACE,cAAA;EACA,uBAAA;EACA,crB9KS;AP07FX;;A+Bv8FA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A/B08FF;A+Bx8FE;;EACE,kBAAA;EACA,cAAA;A/B28FJ;AQ18FE;;EuBII,UAAA;A/B08FN;A+Bx8FI;;;;EAGE,UAAA;A/B28FN;;A+Br8FA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A/Bw8FF;A+Bt8FE;EACE,WAAA;A/Bw8FJ;;A+Bl8FE;;EAEE,iBAAA;A/Bq8FJ;A+Bj8FE;;ElBXE,0BAAA;EACA,6BAAA;Abg9FJ;A+Bj8FE;;ElBFE,yBAAA;EACA,4BAAA;Abu8FJ;;A+Bp7FA;EACE,wBAAA;EACA,uBAAA;A/Bu7FF;A+Br7FE;EAGE,cAAA;A/Bq7FJ;A+Bl7FE;EACE,eAAA;A/Bo7FJ;;A+Bh7FA;EACE,uBAAA;EACA,sBAAA;A/Bm7FF;;A+Bh7FA;EACE,sBAAA;EACA,qBAAA;A/Bm7FF;;A+B/5FA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A/Bk6FF;A+Bh6FE;;EAEE,WAAA;A/Bk6FJ;A+B/5FE;;EAEE,gBAAA;A/Bi6FJ;A+B75FE;;ElBrFE,6BAAA;EACA,4BAAA;Abs/FJ;A+B75FE;;ElBxGE,yBAAA;EACA,0BAAA;AbygGJ;;A+B94FE;;EAEE,gBAAA;A/Bi5FJ;A+B/4FI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/Bm5FN;;AgC5iGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhC+iGF;AgC7iGE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AhC+iGJ;AgC7iGI;;;;;;;;;;;;EAGE,iBAAA;AhCwjGN;AgCnjGE;;;EAGE,UAAA;AhCqjGJ;AgCjjGE;EACE,UAAA;AhCmjGJ;AgC9iGI;;EnBIA,yBAAA;EACA,4BAAA;Ab8iGJ;AgC9iGE;EACE,aAAA;EACA,mBAAA;AhCgjGJ;AgC9iGI;EnBnBA,0BAAA;EACA,6BAAA;AbokGJ;AgChjGI;EnBPA,yBAAA;EACA,4BAAA;Ab0jGJ;AgChjGI;;;;EnBzBA,0BAAA;EACA,6BAAA;Ab+kGJ;AgC9iGI;;;;EnBlCA,0BAAA;EACA,6BAAA;AbslGJ;;AgCriGA;;EAEE,aAAA;AhCwiGF;AgCniGE;;EACE,kBAAA;EACA,UAAA;AhCsiGJ;AgCpiGI;;EACE,UAAA;AhCuiGN;AgCniGE;;;;;;;;EAIE,iBAAA;AhCyiGJ;;AgCriGA;EAAuB,kBAAA;AhCyiGvB;;AgCxiGA;EAAsB,iBAAA;AhC4iGtB;;AgCpiGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;E1B2DI,eAAA;E0BzDJ,gBzBqK4B;EyBpK5B,gBzByK4B;EyBxK5B,czB/GS;EyBgHT,kBAAA;EACA,mBAAA;EACA,yBzBvHS;EyBwHT,yBAAA;EnB/GE,sBAAA;AbupGJ;AgCpiGE;;EAEE,aAAA;AhCsiGJ;;AgC5hGA;;EAEE,gCzBmWsC;AP4rFxC;;AgC5hGA;;;;;;EAME,oBAAA;E1BwBI,kBAAA;E0BtBJ,gBzB2E4B;EMvN1B,qBAAA;Ab4qGJ;;AgC5hGA;;EAEE,kCzBiVsC;AP8sFxC;;AgC5hGA;;;;;;EAME,uBAAA;E1BOI,mBAAA;E0BLJ,gBzB2D4B;EMxN1B,qBAAA;Ab6rGJ;;AgC5hGA;;EAEE,sBAAA;AhC+hGF;;AgCphGA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;Ab6rGJ;;AgCrhGA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AbyrGJ;;AiCjuGA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;UAAA,yBAAA;AjCouGF;;AiCjuGA;EACE,oBAAA;EACA,kB1ByfsC;AP2uFxC;;AiCjuGA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W1BqfsC;E0BpftC,eAAA;EACA,UAAA;AjCouGF;AiCluGE;EACE,W1BzBO;E0B0BP,qB1ByN0B;EiBpP1B,yBjBoP0B;AP4gG9B;AiChuGE;EAKI,gB/BoBuB;AF0sG7B;AiC1tGE;EACE,qB1BsboC;APsyFxC;AiCztGE;EACE,W1B7CO;E0B8CP,yB1Bkf4C;E0Bjf5C,qB1Bif4C;AP0uFhD;AiCptGI;EACE,c1BjDK;APuwGX;AiCptGM;EACE,yB1BxDG;AP8wGX;;AiC5sGA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AjC8sGF;AiC1sGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1BwboC;E0BvbpC,Y1BuboC;E0BtbpC,oBAAA;EACA,WAAA;EACA,sB1BrFO;E0BsFP,yBAAA;AjC4sGJ;AiCvsGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1ByaoC;E0BxapC,Y1BwaoC;E0BvapC,WAAA;EACA,iCAAA;AjCysGJ;;AiC/rGE;EpBlGE,sBAAA;AbqyGJ;AiC9rGI;EACE,kOAAA;AjCgsGN;AiC3rGI;EACE,qB1B0HwB;EiBpP1B,yBjBoP0B;APokG9B;AiC1rGI;EACE,+KAAA;AjC4rGN;AiCvrGI;ETpIA,wCjByhB4C;APqyFhD;AiCvrGI;ETvIA,wCjByhB4C;APwyFhD;;AiC/qGE;EAEE,kB1B0Z4C;APuxFhD;AiC7qGI;EACE,8KAAA;AjC+qGN;AiC1qGI;ET9JA,wCjByhB4C;APkzFhD;;AiClqGA;EACE,qBAAA;AjCqqGF;AiClqGI;EACE,cAAA;EACA,c1BkY0C;E0BjY1C,mBAAA;EAEA,qB1BgY0C;APmyFhD;AiChqGI;EACE,wBAAA;EACA,0BAAA;EACA,uB1B2X0C;E0B1X1C,wB1B0X0C;E0BzX1C,yB1BpLK;E0BsLL,qB1BsX0C;EexiB1C,yIWmLA;AjCiqGN;AsBh1GM;EWuKF;IXtKI,gBAAA;EtBm1GN;AACF;AiCjqGI;EACE,sB1BlMK;E0BmML,8BAAA;AjCmqGN;AiC9pGI;ETzMA,wCjByhB4C;APi1FhD;;AiCppGA;EACE,qBAAA;EACA,WAAA;EACA,mC1BqRsC;E0BpRtC,0CAAA;E3B5CI,eAAA;E2B+CJ,gB1B6D4B;E0B5D5B,gB1BiE4B;E0BhE5B,c1BvNS;E0BwNT,sBAAA;EACA,uOAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,wBAAA;UAAA,gBAAA;AjCqpGF;AiCnpGE;EACE,qB1BwPoC;E0BvPpC,UAAA;EAKE,gD1BmW8B;AP8yFpC;AiC9oGI;EAME,c1B/OK;E0BgPL,sB1BvPK;APk4GX;AiCvoGE;EAEE,YAAA;EACA,sB1B+H0B;E0B9H1B,sBAAA;AjCwoGJ;AiCroGE;EACE,c1B7PO;E0B8PP,yB1BlQO;APy4GX;AiCnoGE;EACE,aAAA;AjCqoGJ;AiCjoGE;EACE,kBAAA;EACA,0BAAA;AjCmoGJ;;AiC/nGA;EACE,kC1B0NsC;E0BzNtC,oB1BiH4B;E0BhH5B,uB1BgH4B;E0B/G5B,oB1BgH4B;ED1NxB,mBAAA;AN6uGN;;AiC/nGA;EACE,gC1BmNsC;E0BlNtC,mB1B8G4B;E0B7G5B,sB1B6G4B;E0B5G5B,kB1B6G4B;ED/NxB,kBAAA;ANqvGN;;AiC1nGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC1BiMsC;E0BhMtC,gBAAA;AjC6nGF;;AiC1nGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC1ByLsC;E0BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;AjC6nGF;AiC3nGE;EACE,qB1BqKoC;E0BpKpC,gB/BnQyB;AFg4G7B;AiCznGE;EAEE,yB1B/TO;APy7GX;AiCtnGI;EACE,iB1B2Ta;AP6zFnB;AiCpnGE;EACE,0BAAA;AjCsnGJ;;AiClnGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC1BwJsC;E0BvJtC,yBAAA;EACA,gBAAA;EAEA,gB1BhE4B;E0BiE5B,gB1B5D4B;E0B6D5B,c1BpVS;E0BqVT,sB1B5VS;E0B6VT,yBAAA;EpBlVE,sBAAA;Abu8GJ;AiCjnGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B1BiIoC;E0BhIpC,yBAAA;EACA,gB1B5E0B;E0B6E1B,c1BpWO;E0BqWP,iBAAA;ET7WA,yBjBGO;E0B4WP,oBAAA;EpBnWA,kCAAA;Abu9GJ;;AiCzmGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AjC4mGF;AiC1mGE;EACE,UAAA;AjC4mGJ;AiCxmGI;EAA0B,mC1BoOe;APu4F7C;AiC1mGI;EAA0B,mC1BmOe;AP04F7C;AiC5mGI;EAA0B,mC1BkOe;AP64F7C;AiC5mGE;EACE,SAAA;AjC8mGJ;AiC3mGE;EACE,W1BoNyC;E0BnNzC,Y1BmNyC;E0BlNzC,oBAAA;ETlZA,yBjBoP0B;E0BgK1B,S1BmNyC;EM3lBzC,mBAAA;ESFE,oHW6YF;EX7YE,4GW6YF;EACA,wBAAA;UAAA,gBAAA;AjC4mGJ;AsBt/GM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;EtBy/GN;AACF;AiC/mGI;ET1ZA,yBjB4mByC;APg6F7C;AiC7mGE;EACE,W1B6LgC;E0B5LhC,c1B6LgC;E0B5LhC,kBAAA;EACA,e1B4LgC;E0B3LhC,yB1BhaO;E0BiaP,yBAAA;EpBzZA,mBAAA;AbygHJ;AiC3mGE;EACE,W1ByLyC;E0BxLzC,Y1BwLyC;EiBpmBzC,yBjBoP0B;E0B0L1B,S1ByLyC;EM3lBzC,mBAAA;ESFE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;AjC4mGJ;AsBhhHM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;EtBmhHN;AACF;AiC/mGI;ETpbA,yBjB4mByC;AP07F7C;AiC7mGE;EACE,W1BmKgC;E0BlKhC,c1BmKgC;E0BlKhC,kBAAA;EACA,e1BkKgC;E0BjKhC,yB1B1bO;E0B2bP,yBAAA;EpBnbA,mBAAA;AbmiHJ;AiC3mGE;EACE,W1B+JyC;E0B9JzC,Y1B8JyC;E0B7JzC,aAAA;EACA,oB1BrE0B;E0BsE1B,mB1BtE0B;EiBnY1B,yBjBoP0B;E0BuN1B,S1B4JyC;EM3lBzC,mBAAA;ESFE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;AjC4mGJ;AsB7iHM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;EtBgjHN;AACF;AiC/mGI;ETjdA,yBjB4mByC;APu9F7C;AiC7mGE;EACE,W1BsIgC;E0BrIhC,c1BsIgC;E0BrIhC,kBAAA;EACA,e1BqIgC;E0BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;AjC+mGJ;AiC3mGE;EACE,yB1B9dO;EMQP,mBAAA;AbokHJ;AiC1mGE;EACE,kBAAA;EACA,yB1BpeO;EMQP,mBAAA;AbykHJ;AiCxmGI;EACE,yB1BxeK;APklHX;AiCvmGI;EACE,eAAA;AjCymGN;AiCtmGI;EACE,yB1BhfK;APwlHX;AiCrmGI;EACE,eAAA;AjCumGN;AiCpmGI;EACE,yB1BxfK;AP8lHX;;AiCjmGA;;;EXzfM,4GW4fJ;AjComGF;AsB5lHM;EWqfN;;;IXpfQ,gBAAA;EtBimHN;AACF;;AkClnHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCqnHF;;AkClnHA;EACE,cAAA;EACA,oBAAA;AlCqnHF;AQpnHE;E0BGE,qBAAA;AlConHJ;AkChnHE;EACE,c3BXO;E2BYP,oBAAA;EACA,eAAA;AlCknHJ;;AkC1mHA;EACE,gCAAA;AlC6mHF;AkC3mHE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;Ab2nHJ;AQvoHE;E0B6BI,kBAAA;EACA,qC3BipB8B;AP49FpC;AkC1mHI;EACE,c3BrCK;E2BsCL,6BAAA;EACA,yBAAA;AlC4mHN;AkCxmHE;;EAEE,c3B5CO;E2B6CP,yBhC5Ca;EgC6Cb,qC3BsoBgC;APo+FpC;AkCvmHE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;Ab+oHJ;;AkC9lHE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;Ab+pHJ;AkC9lHE;;EAEE,W3B9EO;E2B+EP,yB3BoK0B;AP47G9B;;AkCtlHE;;EAEE,cAAA;EACA,kBAAA;AlCylHJ;;AkCplHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AlCulHJ;;AkC7kHE;EACE,aAAA;AlCglHJ;AkC9kHE;EACE,cAAA;AlCglHJ;;AmCzrHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AnC4rHF;AmCxrHE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AnC+rHJ;AmC3qHA;EACE,qBAAA;EACA,sB5BkqBkC;E4BjqBlC,yB5BiqBkC;E4BhqBlC,kBjCoEiB;EIyDb,kBAAA;E6B3HJ,oBAAA;EACA,mBAAA;AnC6qHF;AQvtHE;E2B6CE,qBAAA;AnC6qHJ;;AmCpqHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCuqHF;AmCrqHE;EACE,gBAAA;EACA,eAAA;AnCuqHJ;AmCpqHE;EACE,gBAAA;EACA,WAAA;AnCsqHJ;;AmC7pHA;EACE,qBAAA;EACA,mB5BylBkC;E4BxlBlC,sB5BwlBkC;APwkGpC;;AmCppHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AnCqpHF;;AmCjpHA;EACE,wBAAA;E7B8DI,kBAAA;E6B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;Ab6vHJ;AQ/vHE;E2B8GE,qBAAA;AnCopHJ;;AmC9oHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AnCipHF;;AmC9oHA;EACE,gB5BglBkC;E4B/kBlC,gBAAA;AnCipHF;;AiBvtHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC8oHR;AACF;AiBhvHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCmoHN;EmCjoHM;IACE,mBAAA;EnCmoHR;EmCjoHQ;IACE,kBAAA;EnCmoHV;EmChoHQ;IACE,qB5ByhBwB;I4BxhBxB,oB5BwhBwB;EP0mGlC;EmC7nHM;;;;;;IACE,iBAAA;EnCooHR;EmCtnHM;IACE,iBAAA;EnCwnHR;EmCrnHM;IACE,wBAAA;IAGA,gBAAA;EnCqnHR;EmClnHM;IACE,aAAA;EnConHR;AACF;AiBrwHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC2rHR;AACF;AiB7xHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCgrHN;EmC9qHM;IACE,mBAAA;EnCgrHR;EmC9qHQ;IACE,kBAAA;EnCgrHV;EmC7qHQ;IACE,qB5ByhBwB;I4BxhBxB,oB5BwhBwB;EPupGlC;EmC1qHM;;;;;;IACE,iBAAA;EnCirHR;EmCnqHM;IACE,iBAAA;EnCqqHR;EmClqHM;IACE,wBAAA;IAGA,gBAAA;EnCkqHR;EmC/pHM;IACE,aAAA;EnCiqHR;AACF;AiBlzHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnCwuHR;AACF;AiB10HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnC6tHN;EmC3tHM;IACE,mBAAA;EnC6tHR;EmC3tHQ;IACE,kBAAA;EnC6tHV;EmC1tHQ;IACE,qB5ByhBwB;I4BxhBxB,oB5BwhBwB;EPosGlC;EmCvtHM;;;;;;IACE,iBAAA;EnC8tHR;EmChtHM;IACE,iBAAA;EnCktHR;EmC/sHM;IACE,wBAAA;IAGA,gBAAA;EnC+sHR;EmC5sHM;IACE,aAAA;EnC8sHR;AACF;AiB/1HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnCqxHR;AACF;AiBv3HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnC0wHN;EmCxwHM;IACE,mBAAA;EnC0wHR;EmCxwHQ;IACE,kBAAA;EnC0wHV;EmCvwHQ;IACE,qB5ByhBwB;I4BxhBxB,oB5BwhBwB;EPivGlC;EmCpwHM;;;;;;IACE,iBAAA;EnC2wHR;EmC7vHM;IACE,iBAAA;EnC+vHR;EmC5vHM;IACE,wBAAA;IAGA,gBAAA;EnC4vHR;EmCzvHM;IACE,aAAA;EnC2vHR;AACF;AmC5zHI;EAoBI,qBAAA;EACA,2BAAA;AnC2yHR;AmC9zHQ;;;;;;EACE,gBAAA;EACA,eAAA;AnCq0HV;AmClzHQ;EACE,mBAAA;AnCozHV;AmClzHU;EACE,kBAAA;AnCozHZ;AmCjzHU;EACE,qB5ByhBwB;E4BxhBxB,oB5BwhBwB;AP2xGpC;AmC9yHQ;;;;;;EACE,iBAAA;AnCqzHV;AmCvyHQ;EACE,iBAAA;AnCyyHV;AmCtyHQ;EACE,wBAAA;EAGA,gBAAA;AnCsyHV;AmCnyHQ;EACE,aAAA;AnCqyHV;;AmCvxHE;EACE,yB5BigBgC;APyxGpC;AQl/HE;E2B2NI,yB5B8f8B;AP4xGpC;AmCrxHI;EACE,cjC1OU;AFigIhB;AQx/HE;E2BoOM,c5BnEkC;AP01H1C;AmCpxHM;EACE,4BjCxHsB;AF84H9B;AmClxHI;;;;EAIE,c5B/EoC;APm2H1C;AmChxHE;EACE,cjC9PY;EiC+PZ,gC5BsegC;AP4yGpC;AmC/wHE;EACE,mRAAA;AnCixHJ;AmC9wHE;EACE,cjCvQY;AFuhIhB;AmC/wHI;EACE,c5B/FoC;APg3H1C;AQjhIE;E2BmQM,c5BlGkC;APm3H1C;;AmCzwHE;EACE,W5BrRO;APiiIX;AQxhIE;E2B+QI,W5BxRK;APoiIX;AmCvwHI;EACE,+B5B2b8B;AP80GpC;AQ9hIE;E2BwRM,gC5Byb4B;APg1GpC;AmCtwHM;EACE,gC5Bub4B;APi1GpC;AmCpwHI;;;;EAIE,W5B7SK;APmjIX;AmClwHE;EACE,+B5BuagC;E4BtahC,sC5B2agC;APy1GpC;AmCjwHE;EACE,yRAAA;AnCmwHJ;AmChwHE;EACE,+B5B8ZgC;APo2GpC;AmCjwHI;EACE,W5B7TK;APgkIX;AQvjIE;E2BuTM,W5BhUG;APmkIX;;AoCtkIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,yBlCIe;EkCHf,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AbokIJ;AoCtkIE;EACE,eAAA;EACA,cAAA;ApCwkIJ;AoCrkIE;EACE,mBAAA;EACA,sBAAA;ApCukIJ;AoCrkII;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;AbukIJ;AoCrkII;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;Ab8jIJ;AoClkIE;;EAEE,aAAA;ApCokIJ;;AoChkIA;EAGE,cAAA;EAGA,eAAA;EACA,gB7BgxBkC;AP+yGpC;;AoC3jIA;EACE,sB7B0wBkC;APozGpC;;AoC3jIA;EACE,qBAAA;EACA,gBAAA;ApC8jIF;;AoC3jIA;EACE,gBAAA;ApC8jIF;;AQnnIE;E4B0DE,qBAAA;ApC6jIJ;AoC1jIE;EACE,oB7ByvBgC;APm0GpC;;AoCpjIA;EACE,wBAAA;EACA,gBAAA;EAEA,sBlClFU;EkCmFV,6CAAA;ApCsjIF;AoCpjIE;EvBvEE,0DAAA;Ab8nIJ;;AoCljIA;EACE,wBAAA;EAEA,sBlC7FU;EkC8FV,0CAAA;ApCojIF;AoCljIE;EvBlFE,0DAAA;AbuoIJ;;AoC3iIA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;ApC8iIF;;AoC3iIA;EACE,uBAAA;EACA,sBAAA;ApC8iIF;;AoC1iIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB7B6sBkC;EM5zBhC,kCAAA;Ab6pIJ;;AoC1iIA;;;EAGE,cAAA;EACA,WAAA;ApC6iIF;;AoC1iIA;;EvBjHI,2CAAA;EACA,4CAAA;AbgqIJ;;AoC3iIA;;EvBxGI,+CAAA;EACA,8CAAA;AbwpIJ;;AoCxiIE;EACE,mB7BqrBgC;APs3GpC;AiB1oII;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EpC2iIF;EoCziIE;IAEE,YAAA;IACA,kB7ByqB8B;I6BxqB9B,gBAAA;IACA,iB7BuqB8B;EPm4GlC;AACF;;AoC9hIE;EACE,mB7BypBgC;APw4GpC;AiB5pII;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EpCiiIF;EoC9hIE;IAEE,YAAA;IACA,gBAAA;EpC+hIJ;EoC7hII;IACE,cAAA;IACA,cAAA;EpC+hIN;EoC1hIM;IvBzKJ,0BAAA;IACA,6BAAA;EbssIF;EoC3hIQ;;IAGE,0BAAA;EpC4hIV;EoC1hIQ;;IAGE,6BAAA;EpC2hIV;EoCvhIM;IvB1KJ,yBAAA;IACA,4BAAA;EbosIF;EoCxhIQ;;IAGE,yBAAA;EpCyhIV;EoCvhIQ;;IAGE,4BAAA;EpCwhIV;AACF;;AoC3gIE;EACE,sB7B8kBgC;APg8GpC;AiBtsII;EmBsLJ;IAMI,oB7B2lBgC;S6B3lBhC,e7B2lBgC;I6B1lBhC,wB7B2lBgC;S6B3lBhC,mB7B2lBgC;I6B1lBhC,UAAA;IACA,SAAA;EpC8gIF;EoC5gIE;IACE,qBAAA;IACA,WAAA;EpC8gIJ;AACF;;AoCrgIA;EACE,qBAAA;ApCwgIF;AoCtgIE;EACE,gBAAA;ApCwgIJ;AoCtgII;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AbgvIJ;AoCtgII;EvBzPA,yBAAA;EACA,0BAAA;AbkwIJ;AoCtgII;EvBtQA,gBAAA;EuBwQE,mBAAA;ApCwgIN;;AqClyIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB9BqiCkC;E8BniClC,gBAAA;EACA,yB9BES;EMSP,sBAAA;Ab0xIJ;;AqC/xIE;EACE,oB9ByhCgC;APywGpC;AqChyII;EACE,WAAA;EACA,qB9BqhC8B;E8BphC9B,c9BNK;E8BOL,YAAA;ArCkyIN;AqCxxIE;EACE,0BAAA;ArC0xIJ;AqCvxIE;EACE,qBAAA;ArCyxIJ;AqCtxIE;EACE,c9B1BO;APkzIX;;AsC/zIA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AbozIJ;;AsCh0IA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iB/BoxBkC;E+BnxBlC,c/BmKwC;E+BjKxC,sB/BPS;E+BQT,yBAAA;AtCk0IF;AsCh0IE;EACE,UAAA;EACA,c/B8JsC;E+B7JtC,qBAAA;EACA,yB/BZO;E+BaP,qB/BZO;AP80IX;AsC/zIE;EACE,UAAA;EACA,U/B4wBgC;E+B3wBhC,gBpCmCyB;AF8xI7B;;AsC3zII;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;AbkzIJ;AsC3zII;EzBNA,gCAAA;EACA,mCAAA;Abo0IJ;AsC1zIE;EACE,UAAA;EACA,W/BxCO;E+ByCP,yB/B0M0B;E+BzM1B,qB/ByM0B;APmnI9B;AsCzzIE;EACE,c/BxCO;E+ByCP,oBAAA;EAEA,YAAA;EACA,sB/BlDO;E+BmDP,qB/BhDO;AP02IX;;AuCj3IE;EACE,uBAAA;EjCgLE,kBAAA;EiC9KF,gBhCmO0B;APipI9B;AuC/2IM;E1BqCF,8BAAA;EACA,iCAAA;Ab60IJ;AuC92IM;E1BkBF,+BAAA;EACA,kCAAA;Ab+1IJ;;AuC/3IE;EACE,uBAAA;EjCgLE,mBAAA;EiC9KF,gBhCoO0B;AP8pI9B;AuC73IM;E1BqCF,8BAAA;EACA,iCAAA;Ab21IJ;AuC53IM;E1BkBF,+BAAA;EACA,kCAAA;Ab62IJ;;AwC34IA;EACE,qBAAA;EACA,qBAAA;ElC6JE,cAAA;EkC3JF,gBjCwR4B;EiCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;AxC84IF;AsBz4IM;EkBfN;IlBgBQ,gBAAA;EtB44IN;AACF;AQl5IE;EgCGI,qBAAA;AxCk5IN;;AwC74IE;EACE,aAAA;AxCg5IJ;;AwC34IA;EACE,kBAAA;EACA,SAAA;AxC84IF;;AwCv4IA;EACE,oBjCi4BkC;EiCh4BlC,mBjCg4BkC;EMv5BhC,oBAAA;Abk6IJ;;AwCl4IE;ECjDA,WAAA;EACA,yBlC0Ea;AP62If;AQz6IE;EiCVI,WAAA;EACA,yBAAA;AzCs7IN;AyCn7II;EAEE,UAAA;EACA,+CAAA;AzCo7IN;;AwC/4IE;ECjDA,WAAA;EACA,yBlC0Ea;AP03If;AQt7IE;EiCVI,WAAA;EACA,yBAAA;AzCm8IN;AyCh8II;EAEE,UAAA;EACA,iDAAA;AzCi8IN;;AwC55IE;ECjDA,WAAA;EACA,yBlC0Ea;APu4If;AQn8IE;EiCVI,WAAA;EACA,yBAAA;AzCg9IN;AyC78II;EAEE,UAAA;EACA,+CAAA;AzC88IN;;AwCz6IE;ECjDA,WAAA;EACA,yBlC0Ea;APo5If;AQh9IE;EiCVI,WAAA;EACA,yBAAA;AzC69IN;AyC19II;EAEE,UAAA;EACA,+CAAA;AzC29IN;;AwCt7IE;ECjDA,cAAA;EACA,yBlC0Ea;APi6If;AQ79IE;EiCVI,cAAA;EACA,yBAAA;AzC0+IN;AyCv+II;EAEE,UAAA;EACA,gDAAA;AzCw+IN;;AwCn8IE;ECjDA,WAAA;EACA,yBlC0Ea;AP86If;AQ1+IE;EiCVI,WAAA;EACA,yBAAA;AzCu/IN;AyCp/II;EAEE,UAAA;EACA,+CAAA;AzCq/IN;;AwCh9IE;ECjDA,cAAA;EACA,yBlC0Ea;AP27If;AQv/IE;EiCVI,cAAA;EACA,yBAAA;AzCogJN;AyCjgJI;EAEE,UAAA;EACA,iDAAA;AzCkgJN;;AwC79IE;ECjDA,WAAA;EACA,yBlC0Ea;APw8If;AQpgJE;EiCVI,WAAA;EACA,yBAAA;AzCihJN;AyC9gJI;EAEE,UAAA;EACA,8CAAA;AzC+gJN;;A0C5hJA;EACE,kBAAA;EACA,mBnCyzBkC;EmCvzBlC,yBnCKS;EMSP,qBAAA;AbihJJ;AiBv+II;EyB5DJ;IAQI,kBAAA;E1C+hJF;AACF;;A0C5hJA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;Ab4hJJ;;A2C1iJA;EACE,kBAAA;EACA,wBAAA;EACA,mBpCy9BkC;EoCx9BlC,6BAAA;E9BUE,sBAAA;AboiJJ;;A2CziJA;EAEE,cAAA;A3C2iJF;;A2CviJA;EACE,gBpC6Q4B;AP6xI9B;;A2CliJA;EACE,mBAAA;A3CqiJF;A2CliJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;A3CoiJJ;;A2C1hJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C+hJvE;A4C3kJE;EACE,yBAAA;A5C6kJJ;A4C1kJE;EACE,cAAA;A5C4kJJ;;A2CtiJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C2iJvE;A4CvlJE;EACE,yBAAA;A5CylJJ;A4CtlJE;EACE,cAAA;A5CwlJJ;;A2CljJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CujJvE;A4CnmJE;EACE,yBAAA;A5CqmJJ;A4ClmJE;EACE,cAAA;A5ComJJ;;A2C9jJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CmkJvE;A4C/mJE;EACE,yBAAA;A5CinJJ;A4C9mJE;EACE,cAAA;A5CgnJJ;;A2C1kJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C+kJvE;A4C3nJE;EACE,yBAAA;A5C6nJJ;A4C1nJE;EACE,cAAA;A5C4nJJ;;A2CtlJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C2lJvE;A4CvoJE;EACE,yBAAA;A5CyoJJ;A4CtoJE;EACE,cAAA;A5CwoJJ;;A2ClmJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CumJvE;A4CnpJE;EACE,yBAAA;A5CqpJJ;A4ClpJE;EACE,cAAA;A5CopJJ;;A2C9mJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CmnJvE;A4C/pJE;EACE,yBAAA;A5CiqJJ;A4C9pJE;EACE,cAAA;A5CgqJJ;;A6CxqJE;EACE;IAAO,2BAAA;E7C4qJT;E6C3qJE;IAAK,wBAAA;E7C8qJP;AACF;A6C3qJA;EACE,aAAA;EACA,YtCk+BkC;EsCj+BlC,gBAAA;EACA,cAAA;EvCwKI,kBAAA;EuCtKJ,yBtCLS;EMSP,sBAAA;Ab0qJJ;;A6CzqJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WtCjBS;EsCkBT,kBAAA;EACA,mBAAA;EACA,yBtCu9BkC;Eel+B9B,2BuBYJ;A7C4qJF;AsBprJM;EuBDN;IvBEQ,gBAAA;EtBurJN;AACF;;A6C9qJA;ErBYE,qMAAA;EqBVA,0BAAA;A7CirJF;;A6C7qJE;EACE,kDAAA;A7CgrJJ;A6C7qJM;EAJJ;IAKM,eAAA;E7CgrJN;AACF;;A8C3tJA;EACE,aAAA;EACA,uBAAA;A9C8tJF;;A8C3tJA;EACE,OAAA;A9C8tJF;;A+ChuJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;Ab0tJJ;;A+CxtJA;EACE,WAAA;EACA,cxCRS;EwCST,mBAAA;A/C2tJF;AQluJE;EuCWE,UAAA;EACA,cxCdO;EwCeP,qBAAA;EACA,yBxCtBO;APgvJX;A+CvtJE;EACE,c7CrBY;E6CsBZ,yBxC1BO;APmvJX;;A+ChtJA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBxC3CS;EwC4CT,sCAAA;A/CitJF;A+C/sJE;ElC1BE,+BAAA;EACA,gCAAA;Ab4uJJ;A+C/sJE;ElChBE,mCAAA;EACA,kCAAA;AbkuJJ;A+C/sJE;EAEE,cxClDO;EwCmDP,oBAAA;EACA,sBxC1DO;AP0wJX;A+C5sJE;EACE,UAAA;EACA,WxChEO;EwCiEP,yBxCkL0B;EwCjL1B,qBxCiL0B;AP6hJ9B;A+C3sJE;EACE,mBAAA;A/C6sJJ;A+C3sJI;EACE,gBAAA;EACA,qBxC2JwB;APkjJ9B;;A+C/rJI;EACE,mBAAA;A/CksJN;A+C/rJQ;ElC1BJ,kCAAA;EAZA,0BAAA;AbyuJJ;A+C9rJQ;ElC3CJ,gCAAA;EAYA,4BAAA;AbiuJJ;A+C7rJQ;EACE,aAAA;A/C+rJV;A+C5rJQ;EACE,qBxC0HoB;EwCzHpB,oBAAA;A/C8rJV;A+C5rJU;EACE,iBAAA;EACA,sBxCqHkB;APykJ9B;;AiBzvJI;E8BmCA;IACE,mBAAA;E/C0tJJ;E+CvtJM;IlC1BJ,kCAAA;IAZA,0BAAA;EbiwJF;E+CttJM;IlC3CJ,gCAAA;IAYA,4BAAA;EbyvJF;E+CrtJM;IACE,aAAA;E/CutJR;E+CptJM;IACE,qBxC0HoB;IwCzHpB,oBAAA;E/CstJR;E+CptJQ;IACE,iBAAA;IACA,sBxCqHkB;EPimJ5B;AACF;AiBlxJI;E8BmCA;IACE,mBAAA;E/CkvJJ;E+C/uJM;IlC1BJ,kCAAA;IAZA,0BAAA;EbyxJF;E+C9uJM;IlC3CJ,gCAAA;IAYA,4BAAA;EbixJF;E+C7uJM;IACE,aAAA;E/C+uJR;E+C5uJM;IACE,qBxC0HoB;IwCzHpB,oBAAA;E/C8uJR;E+C5uJQ;IACE,iBAAA;IACA,sBxCqHkB;EPynJ5B;AACF;AiB1yJI;E8BmCA;IACE,mBAAA;E/C0wJJ;E+CvwJM;IlC1BJ,kCAAA;IAZA,0BAAA;EbizJF;E+CtwJM;IlC3CJ,gCAAA;IAYA,4BAAA;EbyyJF;E+CrwJM;IACE,aAAA;E/CuwJR;E+CpwJM;IACE,qBxC0HoB;IwCzHpB,oBAAA;E/CswJR;E+CpwJQ;IACE,iBAAA;IACA,sBxCqHkB;EPipJ5B;AACF;AiBl0JI;E8BmCA;IACE,mBAAA;E/CkyJJ;E+C/xJM;IlC1BJ,kCAAA;IAZA,0BAAA;Eby0JF;E+C9xJM;IlC3CJ,gCAAA;IAYA,4BAAA;Ebi0JF;E+C7xJM;IACE,aAAA;E/C+xJR;E+C5xJM;IACE,qBxC0HoB;IwCzHpB,oBAAA;E/C8xJR;E+C5xJQ;IACE,iBAAA;IACA,sBxCqHkB;EPyqJ5B;AACF;A+CjxJA;ElCnHI,gBAAA;Abu4JJ;A+CjxJE;EACE,qBAAA;A/CmxJJ;A+CjxJI;EACE,sBAAA;A/CmxJN;;AgD55JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C4wJ3C;AQp5JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD85JR;AgD35JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/CqxJ1E;;AgD16JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C0xJ3C;AQl6JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD46JR;AgDz6JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/CmyJ1E;;AgDx7JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CwyJ3C;AQh7JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD07JR;AgDv7JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/CizJ1E;;AgDt8JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CszJ3C;AQ97JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDw8JR;AgDr8JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/C+zJ1E;;AgDp9JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Co0J3C;AQ58JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDs9JR;AgDn9JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/C60J1E;;AgDl+JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Ck1J3C;AQ19JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDo+JR;AgDj+JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/C21J1E;;AgDh/JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Cg2J3C;AQx+JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDk/JR;AgD/+JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/Cy2J1E;;AgD9/JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C82J3C;AQt/JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDggKR;AgD7/JM;EACE,WzCPG;EyCQH,yBDyIkE;ECxIlE,qBDwIkE;A/Cu3J1E;;AiD/gKA;EACE,YAAA;E3CmLI,iBAAA;E2CjLJ,gB1C8R4B;E0C7R5B,cAAA;EACA,W1CYS;E0CXT,yB1CylCkC;E0CxlClC,YAAA;AjDkhKF;AQ7gKE;EyCDE,W1CMO;E0CLP,qBAAA;AjDihKJ;AQ7gKE;EyCCI,aAAA;AjD+gKN;;AiDpgKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AjDugKF;;AiDjgKA;EACE,oBAAA;AjDogKF;;AkD1iKA;EAGE,iB3C24BkC;E2C14BlC,gB3C04BkC;ED1tB9B,mBAAA;E4C7KJ,2C3C44BkC;E2C34BlC,4BAAA;EACA,oCAAA;EACA,gD3C64BkC;E2C54BlC,UAAA;ErCOE,sBAAA;AboiKJ;AkDxiKE;EACE,sB3Cg4BgC;AP0qIpC;AkDviKE;EACE,UAAA;AlDyiKJ;AkDtiKE;EACE,cAAA;EACA,UAAA;AlDwiKJ;AkDriKE;EACE,aAAA;AlDuiKJ;;AkDniKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c3CvBS;E2CwBT,2C3Cq3BkC;E2Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AbmjKJ;;AkDpiKA;EACE,gB3Cm2BkC;APosIpC;;AmD7kKA;EAEE,gBAAA;AnD+kKF;AmD7kKE;EACE,kBAAA;EACA,gBAAA;AnD+kKJ;;AmD1kKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C4pBkC;E4C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AnD2kKF;;AmDpkKA;EACE,kBAAA;EACA,WAAA;EACA,c5Ci5BkC;E4C/4BlC,oBAAA;AnDskKF;AmDnkKE;E7B3BI,mC6B4BF;EACA,8B5Cu6BgC;AP8pIpC;AsB9lKM;E6BuBJ;I7BtBM,gBAAA;EtBimKN;AACF;AmDxkKE;EACE,e5Cq6BgC;APqqIpC;AmDtkKE;EACE,sB5Ck6BgC;APsqIpC;;AmDpkKA;EACE,aAAA;EACA,6BAAA;AnDukKF;AmDrkKE;EACE,8BAAA;EACA,gBAAA;AnDukKJ;AmDpkKE;;EAEE,cAAA;AnDskKJ;AmDnkKE;EACE,gBAAA;AnDqkKJ;;AmDjkKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AnDokKF;AmDjkKE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AnDmkKJ;AmD/jKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AnDikKJ;AmD/jKI;EACE,gBAAA;AnDikKN;AmD9jKI;EACE,aAAA;AnDgkKN;;AmD1jKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB5C3GS;E4C4GT,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AnDyjKF;;AmDrjKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CgjBkC;E4C/iBlC,YAAA;EACA,aAAA;EACA,sB5ClHS;AP0qKX;AmDrjKE;EAAS,UAAA;AnDwjKX;AmDvjKE;EAAS,Y5C+zByB;AP2vIpC;;AmDrjKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB5C6zBkC;E4C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;Ab+qKJ;AmDvjKE;EACE,kB5CwzBgC;E4CtzBhC,8BAAA;AnDwjKJ;;AmDnjKA;EACE,gBAAA;EACA,gB5CuI4B;AP+6J9B;;AmDjjKA;EACE,kBAAA;EAGA,cAAA;EACA,a5C0wBkC;APwyIpC;;AmD9iKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;Ab2rKJ;AmD7iKE;EACE,eAAA;AnD+iKJ;;AmD1iKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AnD6iKF;;AiBprKI;EkC6IF;IACE,gB5CuwBgC;I4CtwBhC,oBAAA;EnD2iKF;EmDxiKA;IACE,+BAAA;EnD0iKF;EmDxiKE;IACE,gCAAA;EnD0iKJ;EmDtiKA;IACE,+BAAA;EnDwiKF;EmDtiKE;IACE,4BAAA;IACA,mBAAA;EnDwiKJ;EmDhiKA;IAAY,gB5C+uBsB;EPozIlC;AACF;AiB3sKI;EkC2KF;;IAEE,gB5CuuBgC;EP4zIlC;AACF;AiBjtKI;EkCkLF;IAAY,iB5CiuBsB;EPk0IlC;AACF;AoDjxKA;EACE,kBAAA;EACA,a7CgrBkC;E6C/qBlC,cAAA;EACA,S7C61BkC;E8Cj2BlC,wBnDkDgB;EmDhDhB,kBAAA;EACA,gB9C4R4B;E8C3R5B,gB9CgS4B;E8C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;E8CzKJ,qBAAA;EACA,UAAA;ApD6xKF;AoD3xKE;EAAS,Y7Ci1ByB;AP68IpC;AoD5xKE;EACE,kBAAA;EACA,cAAA;EACA,a7Ci1BgC;E6Ch1BhC,c7Ci1BgC;AP68IpC;AoD5xKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApD8xKN;;AoDzxKA;EACE,iBAAA;ApD4xKF;AoD1xKE;EACE,SAAA;ApD4xKJ;AoD1xKI;EACE,MAAA;EACA,6BAAA;EACA,sB7CvBK;APmzKX;;AoDvxKA;EACE,iBAAA;ApD0xKF;AoDxxKE;EACE,OAAA;EACA,a7CmzBgC;E6ClzBhC,c7CizBgC;APy+IpC;AoDxxKI;EACE,QAAA;EACA,oCAAA;EACA,wB7CvCK;APi0KX;;AoDrxKA;EACE,iBAAA;ApDwxKF;AoDtxKE;EACE,MAAA;ApDwxKJ;AoDtxKI;EACE,SAAA;EACA,6BAAA;EACA,yB7CrDK;AP60KX;;AoDnxKA;EACE,iBAAA;ApDsxKF;AoDpxKE;EACE,QAAA;EACA,a7CqxBgC;E6CpxBhC,c7CmxBgC;APmgJpC;AoDpxKI;EACE,OAAA;EACA,oCAAA;EACA,uB7CrEK;AP21KX;;AoDjwKA;EACE,gB7C+uBkC;E6C9uBlC,uBAAA;EACA,W7CvGS;E6CwGT,kBAAA;EACA,sB7C/FS;EMCP,sBAAA;Abm2KJ;;AsDr3KA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C8qBkC;E+C7qBlC,cAAA;EACA,gB/C+2BkC;E8Cp3BlC,wBnDkDgB;EmDhDhB,kBAAA;EACA,gB9C4R4B;E8C3R5B,gB9CgS4B;E8C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;EgDxKJ,qBAAA;EACA,sB/CNS;E+COT,4BAAA;EACA,oCAAA;EzCGE,qBAAA;Abg4KJ;AsD/3KE;EACE,kBAAA;EACA,cAAA;EACA,W/C+2BgC;E+C92BhC,c/C+2BgC;E+C92BhC,gBAAA;AtDi4KJ;AsD/3KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtDg4KN;;AsD33KA;EACE,qB/Cg2BkC;AP8hJpC;AsD53KE;EACE,2BAAA;AtD83KJ;AsD53KI;EACE,SAAA;EACA,6BAAA;EACA,qC/C21B8B;APmiJpC;AsD33KI;EACE,W/C0LwB;E+CzLxB,6BAAA;EACA,sB/C7CK;AP06KX;;AsDx3KA;EACE,mB/C40BkC;AP+iJpC;AsDz3KE;EACE,yBAAA;EACA,a/Cw0BgC;E+Cv0BhC,Y/Cs0BgC;E+Cr0BhC,gBAAA;AtD23KJ;AsDz3KI;EACE,OAAA;EACA,oCAAA;EACA,uC/Co0B8B;APujJpC;AsDx3KI;EACE,S/CmKwB;E+ClKxB,oCAAA;EACA,wB/CpEK;AP87KX;;AsDr3KA;EACE,kB/CqzBkC;APmkJpC;AsDt3KE;EACE,wBAAA;AtDw3KJ;AsDt3KI;EACE,MAAA;EACA,oCAAA;EACA,wC/CgzB8B;APwkJpC;AsDr3KI;EACE,Q/C+IwB;E+C9IxB,oCAAA;EACA,yB/CxFK;AP+8KX;AsDl3KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W/C4xBgC;E+C3xBhC,oBAAA;EACA,WAAA;EACA,gCAAA;AtDo3KJ;;AsDh3KA;EACE,oB/CqxBkC;AP8lJpC;AsDj3KE;EACE,0BAAA;EACA,a/CixBgC;E+ChxBhC,Y/C+wBgC;E+C9wBhC,gBAAA;AtDm3KJ;AsDj3KI;EACE,QAAA;EACA,oCAAA;EACA,sC/C6wB8B;APsmJpC;AsDh3KI;EACE,U/C4GwB;E+C3GxB,oCAAA;EACA,uB/C3HK;AP6+KX;;AsD51KA;EACE,uBAAA;EACA,gBAAA;EhD0BI,eAAA;EgDxBJ,cpD/Ic;EoDgJd,yB/C+tBkC;E+C9tBlC,gCAAA;EzCnIE,0CAAA;EACA,2CAAA;Abm+KJ;AsD91KE;EACE,aAAA;AtDg2KJ;;AsD51KA;EACE,uBAAA;EACA,cpD3Jc;AF0/KhB;;AuD1/KA;EACE,kBAAA;AvD6/KF;;AuD1/KA;EACE,mBAAA;AvD6/KF;;AuD1/KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvD6/KF;AwDphLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDshLJ;;AuD9/KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;AvDigLF;AsBhhLM;EiCQN;IjCPQ,gBAAA;EtBmhLN;AACF;;AuDngLA;;;EAGE,cAAA;AvDsgLF;;AuDngLA;;EAEE,2BAAA;AvDsgLF;;AuDngLA;;EAEE,4BAAA;AvDsgLF;;AuD7/KE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDggLJ;AuD7/KE;;;EAGE,UAAA;EACA,UAAA;AvD+/KJ;AuD5/KE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;AvD8/KJ;AsBvjLM;EiCqDJ;;IjCpDM,gBAAA;EtB2jLN;AACF;;AuD3/KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDs9BmC;EgDr9BnC,UAAA;EACA,WhD3FS;EgD4FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDi9BmC;EeviC/B,8BiCuFJ;AvD6/KF;AsBhlLM;EiCkEN;;IjCjEQ,gBAAA;EtBolLN;AACF;AQ1lLE;;;E+C2FE,WhDpGO;EgDqGP,qBAAA;EACA,UAAA;EACA,YhD08BiC;AP0jJrC;;AuDjgLA;EACE,OAAA;AvDogLF;;AuD//KA;EACE,QAAA;AvDkgLF;;AuD3/KA;;EAEE,qBAAA;EACA,WhDm8BmC;EgDl8BnC,YhDk8BmC;EgDj8BnC,mCAAA;AvD8/KF;;AuD5/KA;EACE,sNAAA;AvD+/KF;;AuD7/KA;EACE,uNAAA;AvDggLF;;AuDv/KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDy5BmC;EgDx5BnC,gBhDw5BmC;EgDv5BnC,gBAAA;AvDy/KF;AuDv/KE;EACE,uBAAA;EACA,cAAA;EACA,WhDu5BiC;EgDt5BjC,WhDu5BiC;EgDt5BjC,iBhDw5BiC;EgDv5BjC,gBhDu5BiC;EgDt5BjC,mBAAA;EACA,eAAA;EACA,sBhDnKO;EgDoKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;AvDw/KJ;AsBppLM;EiC6IJ;IjC5IM,gBAAA;EtBupLN;AACF;AuD1/KE;EACE,UAAA;AvD4/KJ;;AuDn/KA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WhD9LS;EgD+LT,kBAAA;AvDs/KF;;AyDxrLA;EACE;IAAK,yBAAA;EzD4rLL;AACF;AyD1rLA;EACE,qBAAA;EACA,WlDskCwB;EkDrkCxB,YlDqkCwB;EkDpkCxB,wBlDskCwB;EkDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AzD2rLF;;AyDxrLA;EACE,WlDgkCwB;EkD/jCxB,YlD+jCwB;EkD9jCxB,mBlDgkCwB;AP2nJ1B;;AyDprLA;EACE;IACE,mBAAA;EzDurLF;EyDrrLA;IACE,UAAA;IACA,eAAA;EzDurLF;AACF;AyDprLA;EACE,qBAAA;EACA,WlDsiCwB;EkDriCxB,YlDqiCwB;EkDpiCxB,wBlDsiCwB;EkDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AzDqrLF;;AyDlrLA;EACE,WlDgiCwB;EkD/hCxB,YlD+hCwB;APspJ1B;;AyDjrLE;EACE;;IAEE,wBAAA;EzDorLJ;AACF;A0DhvLA;EAAqB,mCAAA;A1DmvLrB;;A0DlvLA;EAAqB,8BAAA;A1DsvLrB;;A0DrvLA;EAAqB,iCAAA;A1DyvLrB;;A0DxvLA;EAAqB,iCAAA;A1D4vLrB;;A0D3vLA;EAAqB,sCAAA;A1D+vLrB;;A0D9vLA;EAAqB,mCAAA;A1DkwLrB;;A2DpwLE;EACE,oCAAA;A3DuwLJ;;AQ7vLE;;;EmDLI,oCAAA;A3DwwLN;;A2D9wLE;EACE,oCAAA;A3DixLJ;;AQvwLE;;;EmDLI,oCAAA;A3DkxLN;;A2DxxLE;EACE,oCAAA;A3D2xLJ;;AQjxLE;;;EmDLI,oCAAA;A3D4xLN;;A2DlyLE;EACE,oCAAA;A3DqyLJ;;AQ3xLE;;;EmDLI,oCAAA;A3DsyLN;;A2D5yLE;EACE,oCAAA;A3D+yLJ;;AQryLE;;;EmDLI,oCAAA;A3DgzLN;;A2DtzLE;EACE,oCAAA;A3DyzLJ;;AQ/yLE;;;EmDLI,oCAAA;A3D0zLN;;A2Dh0LE;EACE,oCAAA;A3Dm0LJ;;AQzzLE;;;EmDLI,oCAAA;A3Do0LN;;A2D10LE;EACE,oCAAA;A3D60LJ;;AQn0LE;;;EmDLI,oCAAA;A3D80LN;;A4D70LA;EACE,iCAAA;A5Dg1LF;;A4D70LA;EACE,wCAAA;A5Dg1LF;;A6D31LA;EAAkB,oCAAA;A7D+1LlB;;A6D91LA;EAAkB,wCAAA;A7Dk2LlB;;A6Dj2LA;EAAkB,0CAAA;A7Dq2LlB;;A6Dp2LA;EAAkB,2CAAA;A7Dw2LlB;;A6Dv2LA;EAAkB,yCAAA;A7D22LlB;;A6Dz2LA;EAAmB,oBAAA;A7D62LnB;;A6D52LA;EAAmB,wBAAA;A7Dg3LnB;;A6D/2LA;EAAmB,0BAAA;A7Dm3LnB;;A6Dl3LA;EAAmB,2BAAA;A7Ds3LnB;;A6Dr3LA;EAAmB,yBAAA;A7Dy3LnB;;A6Dt3LE;EACE,gCAAA;A7Dy3LJ;;A6D13LE;EACE,gCAAA;A7D63LJ;;A6D93LE;EACE,gCAAA;A7Di4LJ;;A6Dl4LE;EACE,gCAAA;A7Dq4LJ;;A6Dt4LE;EACE,gCAAA;A7Dy4LJ;;A6D14LE;EACE,gCAAA;A7D64LJ;;A6D94LE;EACE,gCAAA;A7Di5LJ;;A6Dl5LE;EACE,gCAAA;A7Dq5LJ;;A6Dj5LA;EACE,6BAAA;A7Do5LF;;A6D74LA;EACE,gCAAA;A7Dg5LF;;A6D74LA;EACE,iCAAA;A7Dg5LF;;A6D74LA;EACE,0CAAA;EACA,2CAAA;A7Dg5LF;;A6D74LA;EACE,2CAAA;EACA,8CAAA;A7Dg5LF;;A6D74LA;EACE,8CAAA;EACA,6CAAA;A7Dg5LF;;A6D74LA;EACE,0CAAA;EACA,6CAAA;A7Dg5LF;;A6D74LA;EACE,gCAAA;A7Dg5LF;;A6D74LA;EACE,6BAAA;A7Dg5LF;;A6D74LA;EACE,+BAAA;A7Dg5LF;;A6D74LA;EACE,2BAAA;A7Dg5LF;;AwDx9LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD29LJ;;A8Dp9LM;EAAwB,wBAAA;A9Dw9L9B;;A8Dx9LM;EAAwB,0BAAA;A9D49L9B;;A8D59LM;EAAwB,gCAAA;A9Dg+L9B;;A8Dh+LM;EAAwB,yBAAA;A9Do+L9B;;A8Dp+LM;EAAwB,yBAAA;A9Dw+L9B;;A8Dx+LM;EAAwB,6BAAA;A9D4+L9B;;A8D5+LM;EAAwB,8BAAA;A9Dg/L9B;;A8Dh/LM;EAAwB,wBAAA;A9Do/L9B;;A8Dp/LM;EAAwB,+BAAA;A9Dw/L9B;;AiBv8LI;E6CjDE;IAAwB,wBAAA;E9D6/L5B;E8D7/LI;IAAwB,0BAAA;E9DggM5B;E8DhgMI;IAAwB,gCAAA;E9DmgM5B;E8DngMI;IAAwB,yBAAA;E9DsgM5B;E8DtgMI;IAAwB,yBAAA;E9DygM5B;E8DzgMI;IAAwB,6BAAA;E9D4gM5B;E8D5gMI;IAAwB,8BAAA;E9D+gM5B;E8D/gMI;IAAwB,wBAAA;E9DkhM5B;E8DlhMI;IAAwB,+BAAA;E9DqhM5B;AACF;AiBr+LI;E6CjDE;IAAwB,wBAAA;E9D0hM5B;E8D1hMI;IAAwB,0BAAA;E9D6hM5B;E8D7hMI;IAAwB,gCAAA;E9DgiM5B;E8DhiMI;IAAwB,yBAAA;E9DmiM5B;E8DniMI;IAAwB,yBAAA;E9DsiM5B;E8DtiMI;IAAwB,6BAAA;E9DyiM5B;E8DziMI;IAAwB,8BAAA;E9D4iM5B;E8D5iMI;IAAwB,wBAAA;E9D+iM5B;E8D/iMI;IAAwB,+BAAA;E9DkjM5B;AACF;AiBlgMI;E6CjDE;IAAwB,wBAAA;E9DujM5B;E8DvjMI;IAAwB,0BAAA;E9D0jM5B;E8D1jMI;IAAwB,gCAAA;E9D6jM5B;E8D7jMI;IAAwB,yBAAA;E9DgkM5B;E8DhkMI;IAAwB,yBAAA;E9DmkM5B;E8DnkMI;IAAwB,6BAAA;E9DskM5B;E8DtkMI;IAAwB,8BAAA;E9DykM5B;E8DzkMI;IAAwB,wBAAA;E9D4kM5B;E8D5kMI;IAAwB,+BAAA;E9D+kM5B;AACF;AiB/hMI;E6CjDE;IAAwB,wBAAA;E9DolM5B;E8DplMI;IAAwB,0BAAA;E9DulM5B;E8DvlMI;IAAwB,gCAAA;E9D0lM5B;E8D1lMI;IAAwB,yBAAA;E9D6lM5B;E8D7lMI;IAAwB,yBAAA;E9DgmM5B;E8DhmMI;IAAwB,6BAAA;E9DmmM5B;E8DnmMI;IAAwB,8BAAA;E9DsmM5B;E8DtmMI;IAAwB,wBAAA;E9DymM5B;E8DzmMI;IAAwB,+BAAA;E9D4mM5B;AACF;A8DnmMA;EAEI;IAAqB,wBAAA;E9DqmMvB;E8DrmME;IAAqB,0BAAA;E9DwmMvB;E8DxmME;IAAqB,gCAAA;E9D2mMvB;E8D3mME;IAAqB,yBAAA;E9D8mMvB;E8D9mME;IAAqB,yBAAA;E9DinMvB;E8DjnME;IAAqB,6BAAA;E9DonMvB;E8DpnME;IAAqB,8BAAA;E9DunMvB;E8DvnME;IAAqB,wBAAA;E9D0nMvB;E8D1nME;IAAqB,+BAAA;E9D6nMvB;AACF;A+DnpMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A/DqpMF;A+DnpME;EACE,cAAA;EACA,WAAA;A/DqpMJ;A+DlpME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A/DopMJ;;A+D3oMI;EACE,yBAAA;A/D8oMN;;A+D/oMI;EACE,mBAAA;A/DkpMN;;A+DnpMI;EACE,gBAAA;A/DspMN;;A+DvpMI;EACE,iBAAA;A/D0pMN;;A+D3pMI;EACE,yBAAA;A/D8pMN;;A+D/pMI;EACE,mBAAA;A/DkqMN;;A+DnqMI;EACE,gBAAA;A/DsqMN;;A+DvqMI;EACE,iBAAA;A/D0qMN;;AgEnsMI;EAAgC,8BAAA;AhEusMpC;;AgEtsMI;EAAgC,iCAAA;AhE0sMpC;;AgEzsMI;EAAgC,sCAAA;AhE6sMpC;;AgE5sMI;EAAgC,yCAAA;AhEgtMpC;;AgE9sMI;EAA8B,0BAAA;AhEktMlC;;AgEjtMI;EAA8B,4BAAA;AhEqtMlC;;AgEptMI;EAA8B,kCAAA;AhEwtMlC;;AgEvtMI;EAA8B,yBAAA;AhE2tMlC;;AgE1tMI;EAA8B,uBAAA;AhE8tMlC;;AgE7tMI;EAA8B,uBAAA;AhEiuMlC;;AgEhuMI;EAA8B,yBAAA;AhEouMlC;;AgEnuMI;EAA8B,yBAAA;AhEuuMlC;;AgEruMI;EAAoC,sCAAA;AhEyuMxC;;AgExuMI;EAAoC,oCAAA;AhE4uMxC;;AgE3uMI;EAAoC,kCAAA;AhE+uMxC;;AgE9uMI;EAAoC,yCAAA;AhEkvMxC;;AgEjvMI;EAAoC,wCAAA;AhEqvMxC;;AgEnvMI;EAAiC,kCAAA;AhEuvMrC;;AgEtvMI;EAAiC,gCAAA;AhE0vMrC;;AgEzvMI;EAAiC,8BAAA;AhE6vMrC;;AgE5vMI;EAAiC,gCAAA;AhEgwMrC;;AgE/vMI;EAAiC,+BAAA;AhEmwMrC;;AgEjwMI;EAAkC,oCAAA;AhEqwMtC;;AgEpwMI;EAAkC,kCAAA;AhEwwMtC;;AgEvwMI;EAAkC,gCAAA;AhE2wMtC;;AgE1wMI;EAAkC,uCAAA;AhE8wMtC;;AgE7wMI;EAAkC,sCAAA;AhEixMtC;;AgEhxMI;EAAkC,iCAAA;AhEoxMtC;;AgElxMI;EAAgC,2BAAA;AhEsxMpC;;AgErxMI;EAAgC,iCAAA;AhEyxMpC;;AgExxMI;EAAgC,+BAAA;AhE4xMpC;;AgE3xMI;EAAgC,6BAAA;AhE+xMpC;;AgE9xMI;EAAgC,+BAAA;AhEkyMpC;;AgEjyMI;EAAgC,8BAAA;AhEqyMpC;;AiBzxMI;E+ClDA;IAAgC,8BAAA;EhEg1MlC;EgE/0ME;IAAgC,iCAAA;EhEk1MlC;EgEj1ME;IAAgC,sCAAA;EhEo1MlC;EgEn1ME;IAAgC,yCAAA;EhEs1MlC;EgEp1ME;IAA8B,0BAAA;EhEu1MhC;EgEt1ME;IAA8B,4BAAA;EhEy1MhC;EgEx1ME;IAA8B,kCAAA;EhE21MhC;EgE11ME;IAA8B,yBAAA;EhE61MhC;EgE51ME;IAA8B,uBAAA;EhE+1MhC;EgE91ME;IAA8B,uBAAA;EhEi2MhC;EgEh2ME;IAA8B,yBAAA;EhEm2MhC;EgEl2ME;IAA8B,yBAAA;EhEq2MhC;EgEn2ME;IAAoC,sCAAA;EhEs2MtC;EgEr2ME;IAAoC,oCAAA;EhEw2MtC;EgEv2ME;IAAoC,kCAAA;EhE02MtC;EgEz2ME;IAAoC,yCAAA;EhE42MtC;EgE32ME;IAAoC,wCAAA;EhE82MtC;EgE52ME;IAAiC,kCAAA;EhE+2MnC;EgE92ME;IAAiC,gCAAA;EhEi3MnC;EgEh3ME;IAAiC,8BAAA;EhEm3MnC;EgEl3ME;IAAiC,gCAAA;EhEq3MnC;EgEp3ME;IAAiC,+BAAA;EhEu3MnC;EgEr3ME;IAAkC,oCAAA;EhEw3MpC;EgEv3ME;IAAkC,kCAAA;EhE03MpC;EgEz3ME;IAAkC,gCAAA;EhE43MpC;EgE33ME;IAAkC,uCAAA;EhE83MpC;EgE73ME;IAAkC,sCAAA;EhEg4MpC;EgE/3ME;IAAkC,iCAAA;EhEk4MpC;EgEh4ME;IAAgC,2BAAA;EhEm4MlC;EgEl4ME;IAAgC,iCAAA;EhEq4MlC;EgEp4ME;IAAgC,+BAAA;EhEu4MlC;EgEt4ME;IAAgC,6BAAA;EhEy4MlC;EgEx4ME;IAAgC,+BAAA;EhE24MlC;EgE14ME;IAAgC,8BAAA;EhE64MlC;AACF;AiBl4MI;E+ClDA;IAAgC,8BAAA;EhEw7MlC;EgEv7ME;IAAgC,iCAAA;EhE07MlC;EgEz7ME;IAAgC,sCAAA;EhE47MlC;EgE37ME;IAAgC,yCAAA;EhE87MlC;EgE57ME;IAA8B,0BAAA;EhE+7MhC;EgE97ME;IAA8B,4BAAA;EhEi8MhC;EgEh8ME;IAA8B,kCAAA;EhEm8MhC;EgEl8ME;IAA8B,yBAAA;EhEq8MhC;EgEp8ME;IAA8B,uBAAA;EhEu8MhC;EgEt8ME;IAA8B,uBAAA;EhEy8MhC;EgEx8ME;IAA8B,yBAAA;EhE28MhC;EgE18ME;IAA8B,yBAAA;EhE68MhC;EgE38ME;IAAoC,sCAAA;EhE88MtC;EgE78ME;IAAoC,oCAAA;EhEg9MtC;EgE/8ME;IAAoC,kCAAA;EhEk9MtC;EgEj9ME;IAAoC,yCAAA;EhEo9MtC;EgEn9ME;IAAoC,wCAAA;EhEs9MtC;EgEp9ME;IAAiC,kCAAA;EhEu9MnC;EgEt9ME;IAAiC,gCAAA;EhEy9MnC;EgEx9ME;IAAiC,8BAAA;EhE29MnC;EgE19ME;IAAiC,gCAAA;EhE69MnC;EgE59ME;IAAiC,+BAAA;EhE+9MnC;EgE79ME;IAAkC,oCAAA;EhEg+MpC;EgE/9ME;IAAkC,kCAAA;EhEk+MpC;EgEj+ME;IAAkC,gCAAA;EhEo+MpC;EgEn+ME;IAAkC,uCAAA;EhEs+MpC;EgEr+ME;IAAkC,sCAAA;EhEw+MpC;EgEv+ME;IAAkC,iCAAA;EhE0+MpC;EgEx+ME;IAAgC,2BAAA;EhE2+MlC;EgE1+ME;IAAgC,iCAAA;EhE6+MlC;EgE5+ME;IAAgC,+BAAA;EhE++MlC;EgE9+ME;IAAgC,6BAAA;EhEi/MlC;EgEh/ME;IAAgC,+BAAA;EhEm/MlC;EgEl/ME;IAAgC,8BAAA;EhEq/MlC;AACF;AiB1+MI;E+ClDA;IAAgC,8BAAA;EhEgiNlC;EgE/hNE;IAAgC,iCAAA;EhEkiNlC;EgEjiNE;IAAgC,sCAAA;EhEoiNlC;EgEniNE;IAAgC,yCAAA;EhEsiNlC;EgEpiNE;IAA8B,0BAAA;EhEuiNhC;EgEtiNE;IAA8B,4BAAA;EhEyiNhC;EgExiNE;IAA8B,kCAAA;EhE2iNhC;EgE1iNE;IAA8B,yBAAA;EhE6iNhC;EgE5iNE;IAA8B,uBAAA;EhE+iNhC;EgE9iNE;IAA8B,uBAAA;EhEijNhC;EgEhjNE;IAA8B,yBAAA;EhEmjNhC;EgEljNE;IAA8B,yBAAA;EhEqjNhC;EgEnjNE;IAAoC,sCAAA;EhEsjNtC;EgErjNE;IAAoC,oCAAA;EhEwjNtC;EgEvjNE;IAAoC,kCAAA;EhE0jNtC;EgEzjNE;IAAoC,yCAAA;EhE4jNtC;EgE3jNE;IAAoC,wCAAA;EhE8jNtC;EgE5jNE;IAAiC,kCAAA;EhE+jNnC;EgE9jNE;IAAiC,gCAAA;EhEikNnC;EgEhkNE;IAAiC,8BAAA;EhEmkNnC;EgElkNE;IAAiC,gCAAA;EhEqkNnC;EgEpkNE;IAAiC,+BAAA;EhEukNnC;EgErkNE;IAAkC,oCAAA;EhEwkNpC;EgEvkNE;IAAkC,kCAAA;EhE0kNpC;EgEzkNE;IAAkC,gCAAA;EhE4kNpC;EgE3kNE;IAAkC,uCAAA;EhE8kNpC;EgE7kNE;IAAkC,sCAAA;EhEglNpC;EgE/kNE;IAAkC,iCAAA;EhEklNpC;EgEhlNE;IAAgC,2BAAA;EhEmlNlC;EgEllNE;IAAgC,iCAAA;EhEqlNlC;EgEplNE;IAAgC,+BAAA;EhEulNlC;EgEtlNE;IAAgC,6BAAA;EhEylNlC;EgExlNE;IAAgC,+BAAA;EhE2lNlC;EgE1lNE;IAAgC,8BAAA;EhE6lNlC;AACF;AiBllNI;E+ClDA;IAAgC,8BAAA;EhEwoNlC;EgEvoNE;IAAgC,iCAAA;EhE0oNlC;EgEzoNE;IAAgC,sCAAA;EhE4oNlC;EgE3oNE;IAAgC,yCAAA;EhE8oNlC;EgE5oNE;IAA8B,0BAAA;EhE+oNhC;EgE9oNE;IAA8B,4BAAA;EhEipNhC;EgEhpNE;IAA8B,kCAAA;EhEmpNhC;EgElpNE;IAA8B,yBAAA;EhEqpNhC;EgEppNE;IAA8B,uBAAA;EhEupNhC;EgEtpNE;IAA8B,uBAAA;EhEypNhC;EgExpNE;IAA8B,yBAAA;EhE2pNhC;EgE1pNE;IAA8B,yBAAA;EhE6pNhC;EgE3pNE;IAAoC,sCAAA;EhE8pNtC;EgE7pNE;IAAoC,oCAAA;EhEgqNtC;EgE/pNE;IAAoC,kCAAA;EhEkqNtC;EgEjqNE;IAAoC,yCAAA;EhEoqNtC;EgEnqNE;IAAoC,wCAAA;EhEsqNtC;EgEpqNE;IAAiC,kCAAA;EhEuqNnC;EgEtqNE;IAAiC,gCAAA;EhEyqNnC;EgExqNE;IAAiC,8BAAA;EhE2qNnC;EgE1qNE;IAAiC,gCAAA;EhE6qNnC;EgE5qNE;IAAiC,+BAAA;EhE+qNnC;EgE7qNE;IAAkC,oCAAA;EhEgrNpC;EgE/qNE;IAAkC,kCAAA;EhEkrNpC;EgEjrNE;IAAkC,gCAAA;EhEorNpC;EgEnrNE;IAAkC,uCAAA;EhEsrNpC;EgErrNE;IAAkC,sCAAA;EhEwrNpC;EgEvrNE;IAAkC,iCAAA;EhE0rNpC;EgExrNE;IAAgC,2BAAA;EhE2rNlC;EgE1rNE;IAAgC,iCAAA;EhE6rNlC;EgE5rNE;IAAgC,+BAAA;EhE+rNlC;EgE9rNE;IAAgC,6BAAA;EhEisNlC;EgEhsNE;IAAgC,+BAAA;EhEmsNlC;EgElsNE;IAAgC,8BAAA;EhEqsNlC;AACF;AiEhvNI;EAAwB,sBAAA;AjEmvN5B;;AiElvNI;EAAwB,uBAAA;AjEsvN5B;;AiErvNI;EAAwB,sBAAA;AjEyvN5B;;AiBrsNI;EgDtDA;IAAwB,sBAAA;EjEgwN1B;EiE/vNE;IAAwB,uBAAA;EjEkwN1B;EiEjwNE;IAAwB,sBAAA;EjEowN1B;AACF;AiBjtNI;EgDtDA;IAAwB,sBAAA;EjE2wN1B;EiE1wNE;IAAwB,uBAAA;EjE6wN1B;EiE5wNE;IAAwB,sBAAA;EjE+wN1B;AACF;AiB5tNI;EgDtDA;IAAwB,sBAAA;EjEsxN1B;EiErxNE;IAAwB,uBAAA;EjEwxN1B;EiEvxNE;IAAwB,sBAAA;EjE0xN1B;AACF;AiBvuNI;EgDtDA;IAAwB,sBAAA;EjEiyN1B;EiEhyNE;IAAwB,uBAAA;EjEmyN1B;EiElyNE;IAAwB,sBAAA;EjEqyN1B;AACF;AkE3yNE;EAAyB,mCAAA;UAAA,2BAAA;AlE8yN3B;;AkE9yNE;EAAyB,oCAAA;UAAA,4BAAA;AlEkzN3B;;AkElzNE;EAAyB,oCAAA;UAAA,4BAAA;AlEszN3B;;AmEtzNE;EAAsB,yBAAA;AnE0zNxB;;AmE1zNE;EAAsB,2BAAA;AnE8zNxB;;AoE7zNE;EAAyB,2BAAA;ApEi0N3B;;AoEj0NE;EAAyB,6BAAA;ApEq0N3B;;AoEr0NE;EAAyB,6BAAA;ApEy0N3B;;AoEz0NE;EAAyB,0BAAA;ApE60N3B;;AoE70NE;EAAyB,2BAAA;ApEi1N3B;;AoE50NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a7DiqBkC;AP8qMpC;;AoE50NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7DypBkC;APsrMpC;;AoE30NE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a7DipBgC;EP8rMlC;AACF;;AqEz2NA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AtE22NF;;AsEj2NE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AtEm2NJ;;AuEh4NA;EAAa,8DAAA;AvEo4Nb;;AuEn4NA;EAAU,wDAAA;AvEu4NV;;AuEt4NA;EAAa,uDAAA;AvE04Nb;;AuEz4NA;EAAe,2BAAA;AvE64Nf;;AwE54NI;EAAuB,qBAAA;AxEg5N3B;;AwEh5NI;EAAuB,qBAAA;AxEo5N3B;;AwEp5NI;EAAuB,qBAAA;AxEw5N3B;;AwEx5NI;EAAuB,sBAAA;AxE45N3B;;AwE55NI;EAAuB,sBAAA;AxEg6N3B;;AwEh6NI;EAAuB,sBAAA;AxEo6N3B;;AwEp6NI;EAAuB,sBAAA;AxEw6N3B;;AwEx6NI;EAAuB,sBAAA;AxE46N3B;;AwE56NI;EAAuB,uBAAA;AxEg7N3B;;AwEh7NI;EAAuB,uBAAA;AxEo7N3B;;AwEh7NA;EAAU,0BAAA;AxEo7NV;;AwEn7NA;EAAU,2BAAA;AxEu7NV;;AwEn7NA;EAAc,2BAAA;AxEu7Nd;;AwEt7NA;EAAc,4BAAA;AxE07Nd;;AwEx7NA;EAAU,uBAAA;AxE47NV;;AwE37NA;EAAU,wBAAA;AxE+7NV;;AyEx8NQ;EAAgC,oBAAA;AzE48NxC;;AyE38NQ;;EAEE,wBAAA;AzE88NV;;AyE58NQ;;EAEE,0BAAA;AzE+8NV;;AyE78NQ;;EAEE,2BAAA;AzEg9NV;;AyE98NQ;;EAEE,yBAAA;AzEi9NV;;AyEh+NQ;EAAgC,0BAAA;AzEo+NxC;;AyEn+NQ;;EAEE,8BAAA;AzEs+NV;;AyEp+NQ;;EAEE,gCAAA;AzEu+NV;;AyEr+NQ;;EAEE,iCAAA;AzEw+NV;;AyEt+NQ;;EAEE,+BAAA;AzEy+NV;;AyEx/NQ;EAAgC,yBAAA;AzE4/NxC;;AyE3/NQ;;EAEE,6BAAA;AzE8/NV;;AyE5/NQ;;EAEE,+BAAA;AzE+/NV;;AyE7/NQ;;EAEE,gCAAA;AzEggOV;;AyE9/NQ;;EAEE,8BAAA;AzEigOV;;AyEhhOQ;EAAgC,uBAAA;AzEohOxC;;AyEnhOQ;;EAEE,2BAAA;AzEshOV;;AyEphOQ;;EAEE,6BAAA;AzEuhOV;;AyErhOQ;;EAEE,8BAAA;AzEwhOV;;AyEthOQ;;EAEE,4BAAA;AzEyhOV;;AyExiOQ;EAAgC,yBAAA;AzE4iOxC;;AyE3iOQ;;EAEE,6BAAA;AzE8iOV;;AyE5iOQ;;EAEE,+BAAA;AzE+iOV;;AyE7iOQ;;EAEE,gCAAA;AzEgjOV;;AyE9iOQ;;EAEE,8BAAA;AzEijOV;;AyEhkOQ;EAAgC,uBAAA;AzEokOxC;;AyEnkOQ;;EAEE,2BAAA;AzEskOV;;AyEpkOQ;;EAEE,6BAAA;AzEukOV;;AyErkOQ;;EAEE,8BAAA;AzEwkOV;;AyEtkOQ;;EAEE,4BAAA;AzEykOV;;AyExlOQ;EAAgC,qBAAA;AzE4lOxC;;AyE3lOQ;;EAEE,yBAAA;AzE8lOV;;AyE5lOQ;;EAEE,2BAAA;AzE+lOV;;AyE7lOQ;;EAEE,4BAAA;AzEgmOV;;AyE9lOQ;;EAEE,0BAAA;AzEimOV;;AyEhnOQ;EAAgC,2BAAA;AzEonOxC;;AyEnnOQ;;EAEE,+BAAA;AzEsnOV;;AyEpnOQ;;EAEE,iCAAA;AzEunOV;;AyErnOQ;;EAEE,kCAAA;AzEwnOV;;AyEtnOQ;;EAEE,gCAAA;AzEynOV;;AyExoOQ;EAAgC,0BAAA;AzE4oOxC;;AyE3oOQ;;EAEE,8BAAA;AzE8oOV;;AyE5oOQ;;EAEE,gCAAA;AzE+oOV;;AyE7oOQ;;EAEE,iCAAA;AzEgpOV;;AyE9oOQ;;EAEE,+BAAA;AzEipOV;;AyEhqOQ;EAAgC,wBAAA;AzEoqOxC;;AyEnqOQ;;EAEE,4BAAA;AzEsqOV;;AyEpqOQ;;EAEE,8BAAA;AzEuqOV;;AyErqOQ;;EAEE,+BAAA;AzEwqOV;;AyEtqOQ;;EAEE,6BAAA;AzEyqOV;;AyExrOQ;EAAgC,0BAAA;AzE4rOxC;;AyE3rOQ;;EAEE,8BAAA;AzE8rOV;;AyE5rOQ;;EAEE,gCAAA;AzE+rOV;;AyE7rOQ;;EAEE,iCAAA;AzEgsOV;;AyE9rOQ;;EAEE,+BAAA;AzEisOV;;AyEhtOQ;EAAgC,wBAAA;AzEotOxC;;AyEntOQ;;EAEE,4BAAA;AzEstOV;;AyEptOQ;;EAEE,8BAAA;AzEutOV;;AyErtOQ;;EAEE,+BAAA;AzEwtOV;;AyEttOQ;;EAEE,6BAAA;AzEytOV;;AyEjtOQ;EAAwB,2BAAA;AzEqtOhC;;AyEptOQ;;EAEE,+BAAA;AzEutOV;;AyErtOQ;;EAEE,iCAAA;AzEwtOV;;AyEttOQ;;EAEE,kCAAA;AzEytOV;;AyEvtOQ;;EAEE,gCAAA;AzE0tOV;;AyEzuOQ;EAAwB,0BAAA;AzE6uOhC;;AyE5uOQ;;EAEE,8BAAA;AzE+uOV;;AyE7uOQ;;EAEE,gCAAA;AzEgvOV;;AyE9uOQ;;EAEE,iCAAA;AzEivOV;;AyE/uOQ;;EAEE,+BAAA;AzEkvOV;;AyEjwOQ;EAAwB,wBAAA;AzEqwOhC;;AyEpwOQ;;EAEE,4BAAA;AzEuwOV;;AyErwOQ;;EAEE,8BAAA;AzEwwOV;;AyEtwOQ;;EAEE,+BAAA;AzEywOV;;AyEvwOQ;;EAEE,6BAAA;AzE0wOV;;AyEzxOQ;EAAwB,0BAAA;AzE6xOhC;;AyE5xOQ;;EAEE,8BAAA;AzE+xOV;;AyE7xOQ;;EAEE,gCAAA;AzEgyOV;;AyE9xOQ;;EAEE,iCAAA;AzEiyOV;;AyE/xOQ;;EAEE,+BAAA;AzEkyOV;;AyEjzOQ;EAAwB,wBAAA;AzEqzOhC;;AyEpzOQ;;EAEE,4BAAA;AzEuzOV;;AyErzOQ;;EAEE,8BAAA;AzEwzOV;;AyEtzOQ;;EAEE,+BAAA;AzEyzOV;;AyEvzOQ;;EAEE,6BAAA;AzE0zOV;;AyEpzOI;EAAmB,uBAAA;AzEwzOvB;;AyEvzOI;;EAEE,2BAAA;AzE0zON;;AyExzOI;;EAEE,6BAAA;AzE2zON;;AyEzzOI;;EAEE,8BAAA;AzE4zON;;AyE1zOI;;EAEE,4BAAA;AzE6zON;;AiBt0OI;EwDlDI;IAAgC,oBAAA;EzE63OtC;EyE53OM;;IAEE,wBAAA;EzE83OR;EyE53OM;;IAEE,0BAAA;EzE83OR;EyE53OM;;IAEE,2BAAA;EzE83OR;EyE53OM;;IAEE,yBAAA;EzE83OR;EyE74OM;IAAgC,0BAAA;EzEg5OtC;EyE/4OM;;IAEE,8BAAA;EzEi5OR;EyE/4OM;;IAEE,gCAAA;EzEi5OR;EyE/4OM;;IAEE,iCAAA;EzEi5OR;EyE/4OM;;IAEE,+BAAA;EzEi5OR;EyEh6OM;IAAgC,yBAAA;EzEm6OtC;EyEl6OM;;IAEE,6BAAA;EzEo6OR;EyEl6OM;;IAEE,+BAAA;EzEo6OR;EyEl6OM;;IAEE,gCAAA;EzEo6OR;EyEl6OM;;IAEE,8BAAA;EzEo6OR;EyEn7OM;IAAgC,uBAAA;EzEs7OtC;EyEr7OM;;IAEE,2BAAA;EzEu7OR;EyEr7OM;;IAEE,6BAAA;EzEu7OR;EyEr7OM;;IAEE,8BAAA;EzEu7OR;EyEr7OM;;IAEE,4BAAA;EzEu7OR;EyEt8OM;IAAgC,yBAAA;EzEy8OtC;EyEx8OM;;IAEE,6BAAA;EzE08OR;EyEx8OM;;IAEE,+BAAA;EzE08OR;EyEx8OM;;IAEE,gCAAA;EzE08OR;EyEx8OM;;IAEE,8BAAA;EzE08OR;EyEz9OM;IAAgC,uBAAA;EzE49OtC;EyE39OM;;IAEE,2BAAA;EzE69OR;EyE39OM;;IAEE,6BAAA;EzE69OR;EyE39OM;;IAEE,8BAAA;EzE69OR;EyE39OM;;IAEE,4BAAA;EzE69OR;EyE5+OM;IAAgC,qBAAA;EzE++OtC;EyE9+OM;;IAEE,yBAAA;EzEg/OR;EyE9+OM;;IAEE,2BAAA;EzEg/OR;EyE9+OM;;IAEE,4BAAA;EzEg/OR;EyE9+OM;;IAEE,0BAAA;EzEg/OR;EyE//OM;IAAgC,2BAAA;EzEkgPtC;EyEjgPM;;IAEE,+BAAA;EzEmgPR;EyEjgPM;;IAEE,iCAAA;EzEmgPR;EyEjgPM;;IAEE,kCAAA;EzEmgPR;EyEjgPM;;IAEE,gCAAA;EzEmgPR;EyElhPM;IAAgC,0BAAA;EzEqhPtC;EyEphPM;;IAEE,8BAAA;EzEshPR;EyEphPM;;IAEE,gCAAA;EzEshPR;EyEphPM;;IAEE,iCAAA;EzEshPR;EyEphPM;;IAEE,+BAAA;EzEshPR;EyEriPM;IAAgC,wBAAA;EzEwiPtC;EyEviPM;;IAEE,4BAAA;EzEyiPR;EyEviPM;;IAEE,8BAAA;EzEyiPR;EyEviPM;;IAEE,+BAAA;EzEyiPR;EyEviPM;;IAEE,6BAAA;EzEyiPR;EyExjPM;IAAgC,0BAAA;EzE2jPtC;EyE1jPM;;IAEE,8BAAA;EzE4jPR;EyE1jPM;;IAEE,gCAAA;EzE4jPR;EyE1jPM;;IAEE,iCAAA;EzE4jPR;EyE1jPM;;IAEE,+BAAA;EzE4jPR;EyE3kPM;IAAgC,wBAAA;EzE8kPtC;EyE7kPM;;IAEE,4BAAA;EzE+kPR;EyE7kPM;;IAEE,8BAAA;EzE+kPR;EyE7kPM;;IAEE,+BAAA;EzE+kPR;EyE7kPM;;IAEE,6BAAA;EzE+kPR;EyEvkPM;IAAwB,2BAAA;EzE0kP9B;EyEzkPM;;IAEE,+BAAA;EzE2kPR;EyEzkPM;;IAEE,iCAAA;EzE2kPR;EyEzkPM;;IAEE,kCAAA;EzE2kPR;EyEzkPM;;IAEE,gCAAA;EzE2kPR;EyE1lPM;IAAwB,0BAAA;EzE6lP9B;EyE5lPM;;IAEE,8BAAA;EzE8lPR;EyE5lPM;;IAEE,gCAAA;EzE8lPR;EyE5lPM;;IAEE,iCAAA;EzE8lPR;EyE5lPM;;IAEE,+BAAA;EzE8lPR;EyE7mPM;IAAwB,wBAAA;EzEgnP9B;EyE/mPM;;IAEE,4BAAA;EzEinPR;EyE/mPM;;IAEE,8BAAA;EzEinPR;EyE/mPM;;IAEE,+BAAA;EzEinPR;EyE/mPM;;IAEE,6BAAA;EzEinPR;EyEhoPM;IAAwB,0BAAA;EzEmoP9B;EyEloPM;;IAEE,8BAAA;EzEooPR;EyEloPM;;IAEE,gCAAA;EzEooPR;EyEloPM;;IAEE,iCAAA;EzEooPR;EyEloPM;;IAEE,+BAAA;EzEooPR;EyEnpPM;IAAwB,wBAAA;EzEspP9B;EyErpPM;;IAEE,4BAAA;EzEupPR;EyErpPM;;IAEE,8BAAA;EzEupPR;EyErpPM;;IAEE,+BAAA;EzEupPR;EyErpPM;;IAEE,6BAAA;EzEupPR;EyEjpPE;IAAmB,uBAAA;EzEopPrB;EyEnpPE;;IAEE,2BAAA;EzEqpPJ;EyEnpPE;;IAEE,6BAAA;EzEqpPJ;EyEnpPE;;IAEE,8BAAA;EzEqpPJ;EyEnpPE;;IAEE,4BAAA;EzEqpPJ;AACF;AiB/pPI;EwDlDI;IAAgC,oBAAA;EzEqtPtC;EyEptPM;;IAEE,wBAAA;EzEstPR;EyEptPM;;IAEE,0BAAA;EzEstPR;EyEptPM;;IAEE,2BAAA;EzEstPR;EyEptPM;;IAEE,yBAAA;EzEstPR;EyEruPM;IAAgC,0BAAA;EzEwuPtC;EyEvuPM;;IAEE,8BAAA;EzEyuPR;EyEvuPM;;IAEE,gCAAA;EzEyuPR;EyEvuPM;;IAEE,iCAAA;EzEyuPR;EyEvuPM;;IAEE,+BAAA;EzEyuPR;EyExvPM;IAAgC,yBAAA;EzE2vPtC;EyE1vPM;;IAEE,6BAAA;EzE4vPR;EyE1vPM;;IAEE,+BAAA;EzE4vPR;EyE1vPM;;IAEE,gCAAA;EzE4vPR;EyE1vPM;;IAEE,8BAAA;EzE4vPR;EyE3wPM;IAAgC,uBAAA;EzE8wPtC;EyE7wPM;;IAEE,2BAAA;EzE+wPR;EyE7wPM;;IAEE,6BAAA;EzE+wPR;EyE7wPM;;IAEE,8BAAA;EzE+wPR;EyE7wPM;;IAEE,4BAAA;EzE+wPR;EyE9xPM;IAAgC,yBAAA;EzEiyPtC;EyEhyPM;;IAEE,6BAAA;EzEkyPR;EyEhyPM;;IAEE,+BAAA;EzEkyPR;EyEhyPM;;IAEE,gCAAA;EzEkyPR;EyEhyPM;;IAEE,8BAAA;EzEkyPR;EyEjzPM;IAAgC,uBAAA;EzEozPtC;EyEnzPM;;IAEE,2BAAA;EzEqzPR;EyEnzPM;;IAEE,6BAAA;EzEqzPR;EyEnzPM;;IAEE,8BAAA;EzEqzPR;EyEnzPM;;IAEE,4BAAA;EzEqzPR;EyEp0PM;IAAgC,qBAAA;EzEu0PtC;EyEt0PM;;IAEE,yBAAA;EzEw0PR;EyEt0PM;;IAEE,2BAAA;EzEw0PR;EyEt0PM;;IAEE,4BAAA;EzEw0PR;EyEt0PM;;IAEE,0BAAA;EzEw0PR;EyEv1PM;IAAgC,2BAAA;EzE01PtC;EyEz1PM;;IAEE,+BAAA;EzE21PR;EyEz1PM;;IAEE,iCAAA;EzE21PR;EyEz1PM;;IAEE,kCAAA;EzE21PR;EyEz1PM;;IAEE,gCAAA;EzE21PR;EyE12PM;IAAgC,0BAAA;EzE62PtC;EyE52PM;;IAEE,8BAAA;EzE82PR;EyE52PM;;IAEE,gCAAA;EzE82PR;EyE52PM;;IAEE,iCAAA;EzE82PR;EyE52PM;;IAEE,+BAAA;EzE82PR;EyE73PM;IAAgC,wBAAA;EzEg4PtC;EyE/3PM;;IAEE,4BAAA;EzEi4PR;EyE/3PM;;IAEE,8BAAA;EzEi4PR;EyE/3PM;;IAEE,+BAAA;EzEi4PR;EyE/3PM;;IAEE,6BAAA;EzEi4PR;EyEh5PM;IAAgC,0BAAA;EzEm5PtC;EyEl5PM;;IAEE,8BAAA;EzEo5PR;EyEl5PM;;IAEE,gCAAA;EzEo5PR;EyEl5PM;;IAEE,iCAAA;EzEo5PR;EyEl5PM;;IAEE,+BAAA;EzEo5PR;EyEn6PM;IAAgC,wBAAA;EzEs6PtC;EyEr6PM;;IAEE,4BAAA;EzEu6PR;EyEr6PM;;IAEE,8BAAA;EzEu6PR;EyEr6PM;;IAEE,+BAAA;EzEu6PR;EyEr6PM;;IAEE,6BAAA;EzEu6PR;EyE/5PM;IAAwB,2BAAA;EzEk6P9B;EyEj6PM;;IAEE,+BAAA;EzEm6PR;EyEj6PM;;IAEE,iCAAA;EzEm6PR;EyEj6PM;;IAEE,kCAAA;EzEm6PR;EyEj6PM;;IAEE,gCAAA;EzEm6PR;EyEl7PM;IAAwB,0BAAA;EzEq7P9B;EyEp7PM;;IAEE,8BAAA;EzEs7PR;EyEp7PM;;IAEE,gCAAA;EzEs7PR;EyEp7PM;;IAEE,iCAAA;EzEs7PR;EyEp7PM;;IAEE,+BAAA;EzEs7PR;EyEr8PM;IAAwB,wBAAA;EzEw8P9B;EyEv8PM;;IAEE,4BAAA;EzEy8PR;EyEv8PM;;IAEE,8BAAA;EzEy8PR;EyEv8PM;;IAEE,+BAAA;EzEy8PR;EyEv8PM;;IAEE,6BAAA;EzEy8PR;EyEx9PM;IAAwB,0BAAA;EzE29P9B;EyE19PM;;IAEE,8BAAA;EzE49PR;EyE19PM;;IAEE,gCAAA;EzE49PR;EyE19PM;;IAEE,iCAAA;EzE49PR;EyE19PM;;IAEE,+BAAA;EzE49PR;EyE3+PM;IAAwB,wBAAA;EzE8+P9B;EyE7+PM;;IAEE,4BAAA;EzE++PR;EyE7+PM;;IAEE,8BAAA;EzE++PR;EyE7+PM;;IAEE,+BAAA;EzE++PR;EyE7+PM;;IAEE,6BAAA;EzE++PR;EyEz+PE;IAAmB,uBAAA;EzE4+PrB;EyE3+PE;;IAEE,2BAAA;EzE6+PJ;EyE3+PE;;IAEE,6BAAA;EzE6+PJ;EyE3+PE;;IAEE,8BAAA;EzE6+PJ;EyE3+PE;;IAEE,4BAAA;EzE6+PJ;AACF;AiBv/PI;EwDlDI;IAAgC,oBAAA;EzE6iQtC;EyE5iQM;;IAEE,wBAAA;EzE8iQR;EyE5iQM;;IAEE,0BAAA;EzE8iQR;EyE5iQM;;IAEE,2BAAA;EzE8iQR;EyE5iQM;;IAEE,yBAAA;EzE8iQR;EyE7jQM;IAAgC,0BAAA;EzEgkQtC;EyE/jQM;;IAEE,8BAAA;EzEikQR;EyE/jQM;;IAEE,gCAAA;EzEikQR;EyE/jQM;;IAEE,iCAAA;EzEikQR;EyE/jQM;;IAEE,+BAAA;EzEikQR;EyEhlQM;IAAgC,yBAAA;EzEmlQtC;EyEllQM;;IAEE,6BAAA;EzEolQR;EyEllQM;;IAEE,+BAAA;EzEolQR;EyEllQM;;IAEE,gCAAA;EzEolQR;EyEllQM;;IAEE,8BAAA;EzEolQR;EyEnmQM;IAAgC,uBAAA;EzEsmQtC;EyErmQM;;IAEE,2BAAA;EzEumQR;EyErmQM;;IAEE,6BAAA;EzEumQR;EyErmQM;;IAEE,8BAAA;EzEumQR;EyErmQM;;IAEE,4BAAA;EzEumQR;EyEtnQM;IAAgC,yBAAA;EzEynQtC;EyExnQM;;IAEE,6BAAA;EzE0nQR;EyExnQM;;IAEE,+BAAA;EzE0nQR;EyExnQM;;IAEE,gCAAA;EzE0nQR;EyExnQM;;IAEE,8BAAA;EzE0nQR;EyEzoQM;IAAgC,uBAAA;EzE4oQtC;EyE3oQM;;IAEE,2BAAA;EzE6oQR;EyE3oQM;;IAEE,6BAAA;EzE6oQR;EyE3oQM;;IAEE,8BAAA;EzE6oQR;EyE3oQM;;IAEE,4BAAA;EzE6oQR;EyE5pQM;IAAgC,qBAAA;EzE+pQtC;EyE9pQM;;IAEE,yBAAA;EzEgqQR;EyE9pQM;;IAEE,2BAAA;EzEgqQR;EyE9pQM;;IAEE,4BAAA;EzEgqQR;EyE9pQM;;IAEE,0BAAA;EzEgqQR;EyE/qQM;IAAgC,2BAAA;EzEkrQtC;EyEjrQM;;IAEE,+BAAA;EzEmrQR;EyEjrQM;;IAEE,iCAAA;EzEmrQR;EyEjrQM;;IAEE,kCAAA;EzEmrQR;EyEjrQM;;IAEE,gCAAA;EzEmrQR;EyElsQM;IAAgC,0BAAA;EzEqsQtC;EyEpsQM;;IAEE,8BAAA;EzEssQR;EyEpsQM;;IAEE,gCAAA;EzEssQR;EyEpsQM;;IAEE,iCAAA;EzEssQR;EyEpsQM;;IAEE,+BAAA;EzEssQR;EyErtQM;IAAgC,wBAAA;EzEwtQtC;EyEvtQM;;IAEE,4BAAA;EzEytQR;EyEvtQM;;IAEE,8BAAA;EzEytQR;EyEvtQM;;IAEE,+BAAA;EzEytQR;EyEvtQM;;IAEE,6BAAA;EzEytQR;EyExuQM;IAAgC,0BAAA;EzE2uQtC;EyE1uQM;;IAEE,8BAAA;EzE4uQR;EyE1uQM;;IAEE,gCAAA;EzE4uQR;EyE1uQM;;IAEE,iCAAA;EzE4uQR;EyE1uQM;;IAEE,+BAAA;EzE4uQR;EyE3vQM;IAAgC,wBAAA;EzE8vQtC;EyE7vQM;;IAEE,4BAAA;EzE+vQR;EyE7vQM;;IAEE,8BAAA;EzE+vQR;EyE7vQM;;IAEE,+BAAA;EzE+vQR;EyE7vQM;;IAEE,6BAAA;EzE+vQR;EyEvvQM;IAAwB,2BAAA;EzE0vQ9B;EyEzvQM;;IAEE,+BAAA;EzE2vQR;EyEzvQM;;IAEE,iCAAA;EzE2vQR;EyEzvQM;;IAEE,kCAAA;EzE2vQR;EyEzvQM;;IAEE,gCAAA;EzE2vQR;EyE1wQM;IAAwB,0BAAA;EzE6wQ9B;EyE5wQM;;IAEE,8BAAA;EzE8wQR;EyE5wQM;;IAEE,gCAAA;EzE8wQR;EyE5wQM;;IAEE,iCAAA;EzE8wQR;EyE5wQM;;IAEE,+BAAA;EzE8wQR;EyE7xQM;IAAwB,wBAAA;EzEgyQ9B;EyE/xQM;;IAEE,4BAAA;EzEiyQR;EyE/xQM;;IAEE,8BAAA;EzEiyQR;EyE/xQM;;IAEE,+BAAA;EzEiyQR;EyE/xQM;;IAEE,6BAAA;EzEiyQR;EyEhzQM;IAAwB,0BAAA;EzEmzQ9B;EyElzQM;;IAEE,8BAAA;EzEozQR;EyElzQM;;IAEE,gCAAA;EzEozQR;EyElzQM;;IAEE,iCAAA;EzEozQR;EyElzQM;;IAEE,+BAAA;EzEozQR;EyEn0QM;IAAwB,wBAAA;EzEs0Q9B;EyEr0QM;;IAEE,4BAAA;EzEu0QR;EyEr0QM;;IAEE,8BAAA;EzEu0QR;EyEr0QM;;IAEE,+BAAA;EzEu0QR;EyEr0QM;;IAEE,6BAAA;EzEu0QR;EyEj0QE;IAAmB,uBAAA;EzEo0QrB;EyEn0QE;;IAEE,2BAAA;EzEq0QJ;EyEn0QE;;IAEE,6BAAA;EzEq0QJ;EyEn0QE;;IAEE,8BAAA;EzEq0QJ;EyEn0QE;;IAEE,4BAAA;EzEq0QJ;AACF;AiB/0QI;EwDlDI;IAAgC,oBAAA;EzEq4QtC;EyEp4QM;;IAEE,wBAAA;EzEs4QR;EyEp4QM;;IAEE,0BAAA;EzEs4QR;EyEp4QM;;IAEE,2BAAA;EzEs4QR;EyEp4QM;;IAEE,yBAAA;EzEs4QR;EyEr5QM;IAAgC,0BAAA;EzEw5QtC;EyEv5QM;;IAEE,8BAAA;EzEy5QR;EyEv5QM;;IAEE,gCAAA;EzEy5QR;EyEv5QM;;IAEE,iCAAA;EzEy5QR;EyEv5QM;;IAEE,+BAAA;EzEy5QR;EyEx6QM;IAAgC,yBAAA;EzE26QtC;EyE16QM;;IAEE,6BAAA;EzE46QR;EyE16QM;;IAEE,+BAAA;EzE46QR;EyE16QM;;IAEE,gCAAA;EzE46QR;EyE16QM;;IAEE,8BAAA;EzE46QR;EyE37QM;IAAgC,uBAAA;EzE87QtC;EyE77QM;;IAEE,2BAAA;EzE+7QR;EyE77QM;;IAEE,6BAAA;EzE+7QR;EyE77QM;;IAEE,8BAAA;EzE+7QR;EyE77QM;;IAEE,4BAAA;EzE+7QR;EyE98QM;IAAgC,yBAAA;EzEi9QtC;EyEh9QM;;IAEE,6BAAA;EzEk9QR;EyEh9QM;;IAEE,+BAAA;EzEk9QR;EyEh9QM;;IAEE,gCAAA;EzEk9QR;EyEh9QM;;IAEE,8BAAA;EzEk9QR;EyEj+QM;IAAgC,uBAAA;EzEo+QtC;EyEn+QM;;IAEE,2BAAA;EzEq+QR;EyEn+QM;;IAEE,6BAAA;EzEq+QR;EyEn+QM;;IAEE,8BAAA;EzEq+QR;EyEn+QM;;IAEE,4BAAA;EzEq+QR;EyEp/QM;IAAgC,qBAAA;EzEu/QtC;EyEt/QM;;IAEE,yBAAA;EzEw/QR;EyEt/QM;;IAEE,2BAAA;EzEw/QR;EyEt/QM;;IAEE,4BAAA;EzEw/QR;EyEt/QM;;IAEE,0BAAA;EzEw/QR;EyEvgRM;IAAgC,2BAAA;EzE0gRtC;EyEzgRM;;IAEE,+BAAA;EzE2gRR;EyEzgRM;;IAEE,iCAAA;EzE2gRR;EyEzgRM;;IAEE,kCAAA;EzE2gRR;EyEzgRM;;IAEE,gCAAA;EzE2gRR;EyE1hRM;IAAgC,0BAAA;EzE6hRtC;EyE5hRM;;IAEE,8BAAA;EzE8hRR;EyE5hRM;;IAEE,gCAAA;EzE8hRR;EyE5hRM;;IAEE,iCAAA;EzE8hRR;EyE5hRM;;IAEE,+BAAA;EzE8hRR;EyE7iRM;IAAgC,wBAAA;EzEgjRtC;EyE/iRM;;IAEE,4BAAA;EzEijRR;EyE/iRM;;IAEE,8BAAA;EzEijRR;EyE/iRM;;IAEE,+BAAA;EzEijRR;EyE/iRM;;IAEE,6BAAA;EzEijRR;EyEhkRM;IAAgC,0BAAA;EzEmkRtC;EyElkRM;;IAEE,8BAAA;EzEokRR;EyElkRM;;IAEE,gCAAA;EzEokRR;EyElkRM;;IAEE,iCAAA;EzEokRR;EyElkRM;;IAEE,+BAAA;EzEokRR;EyEnlRM;IAAgC,wBAAA;EzEslRtC;EyErlRM;;IAEE,4BAAA;EzEulRR;EyErlRM;;IAEE,8BAAA;EzEulRR;EyErlRM;;IAEE,+BAAA;EzEulRR;EyErlRM;;IAEE,6BAAA;EzEulRR;EyE/kRM;IAAwB,2BAAA;EzEklR9B;EyEjlRM;;IAEE,+BAAA;EzEmlRR;EyEjlRM;;IAEE,iCAAA;EzEmlRR;EyEjlRM;;IAEE,kCAAA;EzEmlRR;EyEjlRM;;IAEE,gCAAA;EzEmlRR;EyElmRM;IAAwB,0BAAA;EzEqmR9B;EyEpmRM;;IAEE,8BAAA;EzEsmRR;EyEpmRM;;IAEE,gCAAA;EzEsmRR;EyEpmRM;;IAEE,iCAAA;EzEsmRR;EyEpmRM;;IAEE,+BAAA;EzEsmRR;EyErnRM;IAAwB,wBAAA;EzEwnR9B;EyEvnRM;;IAEE,4BAAA;EzEynRR;EyEvnRM;;IAEE,8BAAA;EzEynRR;EyEvnRM;;IAEE,+BAAA;EzEynRR;EyEvnRM;;IAEE,6BAAA;EzEynRR;EyExoRM;IAAwB,0BAAA;EzE2oR9B;EyE1oRM;;IAEE,8BAAA;EzE4oRR;EyE1oRM;;IAEE,gCAAA;EzE4oRR;EyE1oRM;;IAEE,iCAAA;EzE4oRR;EyE1oRM;;IAEE,+BAAA;EzE4oRR;EyE3pRM;IAAwB,wBAAA;EzE8pR9B;EyE7pRM;;IAEE,4BAAA;EzE+pRR;EyE7pRM;;IAEE,8BAAA;EzE+pRR;EyE7pRM;;IAEE,+BAAA;EzE+pRR;EyE7pRM;;IAEE,6BAAA;EzE+pRR;EyEzpRE;IAAmB,uBAAA;EzE4pRrB;EyE3pRE;;IAEE,2BAAA;EzE6pRJ;EyE3pRE;;IAEE,6BAAA;EzE6pRJ;EyE3pRE;;IAEE,8BAAA;EzE6pRJ;EyE3pRE;;IAEE,4BAAA;EzE6pRJ;AACF;A0E9tRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;A1E8tRJ;;A2ExuRA;EAAkB,4GAAA;A3E4uRlB;;A2ExuRA;EAAiB,8BAAA;A3E4uRjB;;A2E3uRA;EAAiB,8BAAA;A3E+uRjB;;A2E9uRA;EAAiB,8BAAA;A3EkvRjB;;A2EjvRA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5E8vRF;;A2E/uRI;EAAwB,2BAAA;A3EmvR5B;;A2ElvRI;EAAwB,4BAAA;A3EsvR5B;;A2ErvRI;EAAwB,6BAAA;A3EyvR5B;;AiBptRI;E0DvCA;IAAwB,2BAAA;E3EgwR1B;E2E/vRE;IAAwB,4BAAA;E3EkwR1B;E2EjwRE;IAAwB,6BAAA;E3EowR1B;AACF;AiBhuRI;E0DvCA;IAAwB,2BAAA;E3E2wR1B;E2E1wRE;IAAwB,4BAAA;E3E6wR1B;E2E5wRE;IAAwB,6BAAA;E3E+wR1B;AACF;AiB3uRI;E0DvCA;IAAwB,2BAAA;E3EsxR1B;E2ErxRE;IAAwB,4BAAA;E3EwxR1B;E2EvxRE;IAAwB,6BAAA;E3E0xR1B;AACF;AiBtvRI;E0DvCA;IAAwB,2BAAA;E3EiyR1B;E2EhyRE;IAAwB,4BAAA;E3EmyR1B;E2ElyRE;IAAwB,6BAAA;E3EqyR1B;AACF;A2EhyRA;EAAmB,oCAAA;A3EmyRnB;;A2ElyRA;EAAmB,oCAAA;A3EsyRnB;;A2EryRA;EAAmB,qCAAA;A3EyyRnB;;A2EryRA;EAAuB,2BAAA;A3EyyRvB;;A2ExyRA;EAAuB,+BAAA;A3E4yRvB;;A2E3yRA;EAAuB,2BAAA;A3E+yRvB;;A2E9yRA;EAAuB,2BAAA;A3EkzRvB;;A2EjzRA;EAAuB,8BAAA;A3EqzRvB;;A2EpzRA;EAAuB,6BAAA;A3EwzRvB;;A2EpzRA;EAAc,sBAAA;A3EwzRd;;A6E/1RE;EACE,yBAAA;A7Ek2RJ;;AQx1RE;EqELM,yBAAA;A7Ei2RR;;A6Ev2RE;EACE,yBAAA;A7E02RJ;;AQh2RE;EqELM,yBAAA;A7Ey2RR;;A6E/2RE;EACE,yBAAA;A7Ek3RJ;;AQx2RE;EqELM,yBAAA;A7Ei3RR;;A6Ev3RE;EACE,yBAAA;A7E03RJ;;AQh3RE;EqELM,yBAAA;A7Ey3RR;;A6E/3RE;EACE,yBAAA;A7Ek4RJ;;AQx3RE;EqELM,yBAAA;A7Ei4RR;;A6Ev4RE;EACE,yBAAA;A7E04RJ;;AQh4RE;EqELM,yBAAA;A7Ey4RR;;A6E/4RE;EACE,yBAAA;A7Ek5RJ;;AQx4RE;EqELM,yBAAA;A7Ei5RR;;A6Ev5RE;EACE,yBAAA;A7E05RJ;;AQh5RE;EqELM,yBAAA;A7Ey5RR;;A2El3RA;EAAa,yBAAA;A3Es3Rb;;A2Er3RA;EAAc,yBAAA;A3Ey3Rd;;A2Ev3RA;EAAiB,oCAAA;A3E23RjB;;A2E13RA;EAAiB,0CAAA;A3E83RjB;;A2E13RA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A9Eq7RF;;A2E93RA;EAAwB,gCAAA;A3Ek4RxB;;A2Eh4RA;EACE,iCAAA;EACA,gCAAA;A3Em4RF;;A2E93RA;EAAc,yBAAA;A3Ek4Rd;;A+En8RA;EACE,8BAAA;A/Es8RF;;A+En8RA;EACE,6BAAA;A/Es8RF;;AgFt8RE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;EhFs8RJ;EgFl8RI;IACE,0BAAA;EhFo8RN;EgF37RE;IACE,6BAAA;EhF67RJ;EgF/6RE;IACE,gCAAA;EhFi7RJ;EgF/6RE;;IAEE,yBAAA;IACA,wBAAA;EhFi7RJ;EgF96RE;;IAEE,wBAAA;EhFg7RJ;EgF76RE;;;IAGE,UAAA;IACA,SAAA;EhF+6RJ;EgF56RE;;IAEE,uBAAA;EhF86RJ;EgFt6RE;IACE,QzE2iC8B;EP63PlC;EgFt6RE;IACE,2BAAA;EhFw6RJ;EgFt6RE;IACE,2BAAA;EhFw6RJ;EgFp6RE;IACE,aAAA;EhFs6RJ;EgFp6RE;IACE,sBAAA;EhFs6RJ;EgFn6RE;IACE,oCAAA;EhFq6RJ;EgFn6RI;;IAEE,iCAAA;EhFq6RN;EgFh6RI;;IAEE,oCAAA;EhFk6RN;EgF95RE;IACE,cAAA;EhFg6RJ;EgF95RI;;;;IAIE,qBzE9GG;EP8gST;EgF55RE;IACE,cAAA;IACA,qBzEpHK;EPkhST;AACF;AiFvhSI;EACE,sBAAA;AjFyhSN;AiFthSI;EAEI,aAAA;EACA,gBAAA;EAGA,eAAA;EAEF,qBAAA;AjFohSN;AiFhhSE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAGA,sBAAA;EAIA,2BAAA;AjF6gSJ;;AkFviSA;EACE,kBAAA;EACA,wCAAA;EACA,eAAA;EAEE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AlFyiSJ;AkFriSI;EACE,qBAAA;EAGE,aAAA;EACA,gBAAA;EAEF,mBAAA;EACA,iBAAA;EACA,eAAA;AlFoiSN;AkFjiSI;EACE,qBAAA;EACA,6BAAA;EACA,YAAA;EAEE,mBAAA;EACA,iBAAA;EAEF,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AlFiiSN;AkF/hSM;EAEE,UAAA;AlFgiSR;AkF7hSM;EACE,sBAAA;EACA,UAAA;AlF+hSR;;AmFjlSA;EACE,sBALkC;EAMlC,WAL4B;AnFylS9B;AmFllSE;EAEE,UAR0B;AnF2lS9B;;AoFzlSA;EACE,yBALgC;EAMhC,WAL0B;ApFimS5B;AoF1lSE;EAEE,UARwB;ApFmmS5B;;AqFjmSA;EACE,yBAL+B;EAM/B,WALyB;ArFymS3B;AqFlmSE;EAEE,UARuB;ArF2mS3B;;AsFzmSA;EACE,yBALkC;EAMlC,WAL4B;AtFinS9B;AsF1mSE;EAEE,UAR0B;AtFmnS9B;;AuFjnSA;EACE,yBALkC;EAMlC,WAL4B;AvFynS9B;AuFlnSE;EAEE,UAR0B;AvF2nS9B;;AE9nSA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AsF9LA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AxF6oSF;;AwF1oSA,wBAAA;AAII;EACE,YAAA;AxF0oSN;;AwFroSA;EACE,mBAAA;AxFwoSF;;AwFroSA;EACE,iCAAA;AxFwoSF;;AwFroSA;EACE,wBtFwBgB;EsFvBhB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,wBtFiBgB;EsFhBhB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,wBtFUgB;EsFThB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,wBtFGgB;EsFFhB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,wBtFJgB;EsFKhB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,wBtFXgB;EsFYhB,eAAA;EACA,iBAAA;EACA,gBAAA;AxFwoSF;;AwFroSA;EACE,iBAAA;EACA,iBAAA;AxFwoSF;;AwFroSA;EACE,eAAA;AxFwoSF;;AwFroSA;EACE,yBtFhES;EsFiET,qBtFjES;AFysSX;;AwFroSA;EACE,ctFrES;EsFsET,qBtFtES;AF8sSX;;AwFroSA;;EAEE,eAAA;EACA,iBAAA;EACA,ctFjFS;EsFkFT,eAAA;AxFwoSF;;AwFroSA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AxFwoSF;;AwFroSA;EACE,cAAA;AxFwoSF;;AwFroSA;EACE,0BAAA;EACA,8BAAA;EACA,gCAAA;EACA,ctFpGS;EsFqGT,eAAA;AxFwoSF;;AwFroSA;EACE,YAAA;AxFwoSF;;AwFroSA;EACE,QAAA;EACA,WAAA;AxFwoSF;;AwFroSA;EACE,sBAAA;AxFwoSF;AwFtoSE;EACE,sBAAA;AxFwoSJ;AwFtoSI;EACE,uBAAA;EACA,oCAAA;EACA,0BAAA;EACA,wBtFlFY;EsFmFZ,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,kBAAA;AxFuoSN;AwFpoSI;;EAEE,+CAAA;AxFsoSN;AwFnoSI;EACE,sBAAA;EACA,ctF3IK;EsF4IL,gCAAA;AxFqoSN;;AwFhoSA;EACE,gBtFxJU;AF2xSZ;;AwFhoSA;EACE,mBtFjJe;AFoxSjB;;AwFhoSA;EACE,mBtF1JS;EsF2JT,WtFjKU;AFoySZ;;AwFhoSA;EACE,mBtF7Je;AFgySjB;;AwFhoSA;EACE,eAAA;AxFmoSF;;AwFhoSA;EACE,sBAAA;EACA,eAAA;AxFmoSF;;AwFhoSA;EACE,yBtF1Ke;EsF2Kf,oBAAA;AxFmoSF;;AwFhoSA;EACE,yBtF5Ke;EsF6Kf,gBAAA;AxFmoSF;;AwF/nSE;EACE,aAAA;AxFkoSJ;;AwF9nSA;EACE,cAAA;AxFioSF;;AwF9nSA;EAEE,aAAA;EAEA,YAAA;EACA,eAAA;AxFioSF;;AwF9nSA;EACE,cAAA;AxFioSF;;AwF9nSA;EACE,YAAA;AxFioSF;;AwF9nSA;EACE,YAAA;AxFioSF;;AwF9nSA;EACE,WAAA;AxFioSF;;AwF9nSA;EACE,0BAAA;AxFioSF;;AwF9nSA;EACE,ctFrMQ;EsFsMR,eAAA;AxFioSF;;AwF9nSA;EACE,ctF7NS;AF81SX;;AwF7nSE;EACE,qBAAA;AxFgoSJ;AwF7nSE;EACE,sBAAA;AxF+nSJ;;AwF3nSA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AxF8nSF;;AwF3nSA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;AxF8nSF;;AwF3nSA;EACE,YAAA;EACA,cAAA;EACA,UAAA;AxF8nSF;;AwF3nSA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AxF8nSF;;AwF3nSA;EACE,ctF3QS;EsF4QT,yBAAA;AxF8nSF;;AwF3nSA;EACE,cAAA;AxF8nSF;;AwF3nSA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxF8nSF;;AwF3nSA;EACE,0BAAA;AxF8nSF;;AwF3nSA;EACE,eAAA;AxF8nSF;;AwF3nSA;EACE,ctFtSS;EsFuST,eAAA;AxF8nSF;;AwF3nSA;EACE,WtFjTU;EsFkTV,eAAA;AxF8nSF;;AwF1nSA;EACE,WAAA;EACA,kBAAA;AxF6nSF;AwF3nSE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AxF6nSJ;;AwFznSA;EACE,YAAA;AxF4nSF;;AwFxnSA;EACE,ctFpTW;AF+6Sb;;AwFxnSA;EACE;IACE,yBAAA;ExF2nSF;AACF;AwFxnSA;EACE,kBAAA;AxF0nSF;;AwFvnSA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,0CAAA;AxF0nSF;;AwFvnSA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,yBAAA;EACA,iDAAA;EACA,UAAA;AxF0nSF;;AwFvnSA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AxF0nSF;;AwFvnSA;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AxF0nSF;;AwFvnSA;EACE,yBAAA;EACA,yBAAA;AxF0nSF;;AwFvnSA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AxF0nSF;;AwFvnSA;EACE,sBAAA;AxF0nSF;;AwFvnSA;EACE,YAAA;AxF0nSF;AwFxnSE;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;AxF0nSJ;AwFvnSE;EACE,0CAAA;EACA,kBAAA;AxFynSJ;;AwFpnSA,iCAAA;AACA;EACE,+BAAA;EACA,2BAAA;AxFunSF;;AwFpnSA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AxFunSF;;AwFpnSA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AxFunSF;;AwFpnSA;EACE,WtFjbU;EsFkbV,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBtF/aS;EsFgbT,YAAA;EACA,eAAA;EACA,iBAAA;AxFunSF;;AwFpnSA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,ctFzbS;EsF0bT,mBtFvamB;EsFwanB,YAAA;EACA,eAAA;EACA,iBAAA;AxFunSF;;AwFpnSA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,ctFpcS;EsFqcT,mBtFnce;EsFocf,YAAA;EACA,eAAA;EACA,iBAAA;AxFunSF;;AwFnnSA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBtF3ce;EsF4cf,YAAA;EACA,eAAA;EACA,iBAAA;AxFsnSF;;AwFlnSA;EACE,gBAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,ctF7dS;EsF8dT,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,mBtFreS;EsFseT,UAAA;EACA,WAAA;EACA,kBAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AxFqnSF;;AwFlnSA;EACE,2BAAA;AxFqnSF;;AwFlnSA;EACE,WAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AxFqnSF;;AwFlnSA;EACE,UAAA;AxFqnSF;;AwFlnSA;EACE,qBAAA;EACA,UAAA;AxFqnSF;;AwFlnSA;EACE,YAAA;AxFqnSF;;AwFlnSA;EACE,cAAA;AxFqnSF;;ACpsTA;EACE,kBAAA;ADusTF;;ACpsTA;EACE,mBAAA;ADusTF;;ACjsTM;EACE,mBAAA;ADosTR;;AC5rTI;EACE,4BAAA;EACA,gBAAA;AD+rTN;;AC1rTA;EACE,aAAA;AD6rTF;;AC1rTA;EACE,wBAAA;EACA,wBAAA;AD6rTF;;ACzrTA;EACE;IACE,WAAA;IACA,kBAAA;IACA,gBAAA;ED4rTF;EC3rTE;IACE,gBAAA;ED6rTJ;ECzrTA;IACE,6BAAA;ED2rTF;ECvrTE;IACE,2BAAA;EDyrTJ;ECtrTE;IACE,0BAAA;EDwrTJ;ECprTA;IACE,iCAAA;IACA,iBAAA;EDsrTF;AACF;AArwTA;EACE,sBAAA;AAuwTF;;AApwTA;EACE,WEHU;EFIV,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBEDS;EFET,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAuwTF","sourcesContent":["@import \"../../../styles/styles\";\n\n.modal-dialog {\n  width: 60vw !important;\n}\n\n.company-detail-item {\n  color: $fms-white;\n  padding-left: 10px;\n  margin-top: 0px;\n  padding-top: 8px;\n  background: $fms-blue;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n","/* You can add global styles to this file, and also import other style files */\n@import \"variables\";\n\n@import \"node_modules/bootstrap/scss/bootstrap\";\n\n@import \"node_modules/angular-notifier/styles\";\n\n@import \"primeng/resources/themes/lara-light-blue/theme.css\";\n@import \"primeng/resources/primeng.css\";\n@import \"custom\";\n\n// @import \"@angular/material/prebuilt-themes/deeppurple-amber.css\";\n// @import '~@circlon/angular-tree-component/css/angular-tree-component.css';\n@import \"@ali-hm/angular-tree-component/css/angular-tree-component.css\";\n\n@import \"~@angular/material/prebuilt-themes/indigo-pink.css\";\n\nbody {\n  overflow-x: hidden;\n}\n\n.board-task-filter-datepicker-container .bs-datepicker-container {\n  margin-right: 135px;\n}\n\ndiv.multiselect-dropdown {\n  span.dropdown-btn {\n    span.selected-item {\n      span {\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n.task-groups {\n  .multiselect-dropdown {\n    .dropdown-list {\n      transform: translateY(-112%);\n      overflow: hidden;\n    }\n  }\n}\n\n.visually-hidden {\n  display: none;\n}\n\napp-task-edit typeahead-container {\n  width: calc(100% - 30px);\n  height: 200px !important;\n}\n\n\n@media (max-width: 960px) {\n  .formio-component-datagrid {\n    width: 100%;\n    position: relative;\n    overflow-x: auto;\n    table {\n      min-width: 750px;\n    }\n  }\n\n  .datagrid-table > tbody > tr > td {\n    word-break: normal !important;\n  }\n\n  .datagrid-table {\n    th {\n      min-width: 250px !important;\n    }\n\n    th:last-of-type{\n      min-width: auto !important;\n    }\n  }\n\n  .choices__item.choices__item--selectable {\n    text-overflow: inherit !important;\n    overflow: visible;\n  }\n}\n","\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","// NOTIFIER: CORE STYLES\n\n// Container\n\n.notifier {\n  &__container {\n    * {\n      box-sizing: border-box;\n    }\n\n    &-list {\n      margin: {\n        top: 0;\n        bottom: 0;\n      }\n      padding: {\n        left: 0;\n      }\n      list-style-type: none;\n    }\n  }\n\n  &__notification {\n    display: flex;\n    align-items: center;\n    position: fixed; // Overlay\n    visibility: hidden; // Notifications are hidden by default, and get shown (or animated in) dynamically by the Angular component\n    z-index: 10000; // Pretty much random ...\n\n    // This attribute forces this element to be rendered on a new layer, by the GPU, in order to improve its performance (#perfmatters)\n    will-change: transform;\n\n    // This attribute improves the overall scrolling performance for fixed position elements, such as this one (#perfmatters)\n    // See <https://benfrain.com/improving-css-performance-fixed-position-elements/>\n    backface-visibility: hidden;\n  }\n}\n","// NOTIFIER: MATERIAL THEME\n//\n// This material theme tries its best to look as material-design'ish as possible - round edges, shadows, and small animations.\n// And, of course, thanks to #Google for creating and sharing such an awesome design language!\n// I highly encourage everyone to read into the Material Design specs: <https://material.google.com/>\n\n$notifier-shadow-color: rgba(0, 0, 0, 0.2) !default;\n\n.notifier__notification--material {\n  border-radius: 3px;\n  box-shadow: 0 1px 3px $notifier-shadow-color;\n  cursor: default; // Default cursor, even when hovering over text\n  padding: {\n    top: 11px;\n    right: 26px;\n    bottom: 10px;\n    left: 26px;\n  }\n\n  .notifier__notification {\n    &-message {\n      display: inline-block;\n      margin: {\n        // Reset paragraph default styles\n        top: 0;\n        bottom: 0;\n      }\n      vertical-align: top;\n      line-height: 32px;\n      font-size: 15px;\n    }\n\n    &-button {\n      display: inline-block;\n      transition: opacity 0.2s ease;\n      opacity: 0.5;\n      margin: {\n        right: -10px;\n        left: 10px;\n      }\n      outline: none;\n      border: none;\n      background: none;\n      cursor: pointer; // Make it obvious that the \"button\" (or, more honestly, icon) is clickable (#UX)\n      padding: 6px;\n      width: 32px;\n      height: 32px;\n      vertical-align: top;\n\n      &:hover,\n      &:focus {\n        opacity: 1; // Make me \"feel\" the clickability with a transparency change (#UX)\n      }\n\n      &:active {\n        transform: scale(0.82); // Make me \"feel\" the click by a push back (#UX)\n        opacity: 1;\n      }\n    }\n  }\n}\n","// NOTIFIER: DEFAULT TYPE STYLES\n\n$notifier-default-background-color: #444 !default;\n$notifier-default-font-color: #fff !default;\n$notifier-default-icon-color: #fff !default;\n\n.notifier__notification--default {\n  background-color: $notifier-default-background-color;\n  color: $notifier-default-font-color;\n\n  .notifier__notification-button-icon {\n    // 16x16 fixed size\n    fill: $notifier-default-icon-color;\n  }\n}\n","// NOTIFIER: ERROR TYPE STYLES\n\n$notifier-error-background-color: #d9534f !default;\n$notifier-error-font-color: #fff !default;\n$notifier-error-icon-color: #fff !default;\n\n.notifier__notification--error {\n  background-color: $notifier-error-background-color;\n  color: $notifier-error-font-color;\n\n  .notifier__notification-button-icon {\n    // 16x16 fixed size\n    fill: $notifier-error-icon-color;\n  }\n}\n","// NOTIFIER: INFO TYPE STYLES\n\n$notifier-info-background-color: #5bc0de !default;\n$notifier-info-font-color: #fff !default;\n$notifier-info-icon-color: #fff !default;\n\n.notifier__notification--info {\n  background-color: $notifier-info-background-color;\n  color: $notifier-info-font-color;\n\n  .notifier__notification-button-icon {\n    // 16x16 fixed size\n    fill: $notifier-info-icon-color;\n  }\n}\n","// NOTIFIER: SUCCESS TYPE STYLES\n\n$notifier-success-background-color: #5cb85c !default;\n$notifier-success-font-color: #fff !default;\n$notifier-success-icon-color: #fff !default;\n\n.notifier__notification--success {\n  background-color: $notifier-success-background-color;\n  color: $notifier-success-font-color;\n\n  .notifier__notification-button-icon {\n    // 16x16 fixed size\n    fill: $notifier-success-icon-color;\n  }\n}\n","// NOTIFIER: WARNING TYPE STYLES\n\n$notifier-warning-background-color: #f0ad4e !default;\n$notifier-warning-font-color: #fff !default;\n$notifier-warning-icon-color: #fff !default;\n\n.notifier__notification--warning {\n  background-color: $notifier-warning-background-color;\n  color: $notifier-warning-font-color;\n\n  .notifier__notification-button-icon {\n    // 16x16 fixed size\n    fill: $notifier-warning-icon-color;\n  }\n}\n","@import \"variables\";\n\nbody {\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n}\n\n/* Bootstrap overrides */\n\n.table {\n  thead {\n    th {\n      border: none;\n    }\n  }\n}\n\ntable.fixed-layout {\n  table-layout: fixed;\n}\n\ntd.vertical-align-middle {\n  vertical-align: middle !important;\n}\n\nh1 {\n  font-family: $fms-font-family;\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh2 {\n  font-family: $fms-font-family;\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh3 {\n  font-family: $fms-font-family;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh4 {\n  font-family: $fms-font-family;\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh5 {\n  font-family: $fms-font-family;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh6 {\n  font-family: $fms-font-family;\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.btn {\n  font-weight: bold;\n  border-width: 2px;\n}\n\na.btn {\n  font-size: 1rem;\n}\n\n.btn-secondary {\n  background-color: $fms-gray;\n  border-color: $fms-gray;\n}\n\n.btn-outline-secondary {\n  color: $fms-gray;\n  border-color: $fms-gray;\n}\n\na.link,\na.link:not([href]):not([tabindex]) {\n  font-size: 14px;\n  font-weight: bold;\n  color: $fms-blue;\n  cursor: pointer;\n}\n\na.link-danger {\n  font-size: 14px;\n  font-weight: bold;\n  color: $fms-red !important;\n  cursor: pointer;\n}\n\na.link:hover {\n  color: #0056b3;\n}\n\na.in-text-link {\n  font-size: 14px !important;\n  font-weight: normal !important;\n  text-decoration: none !important;\n  color: $fms-blue;\n  cursor: pointer;\n}\n\n.bs-datepicker.archived-task-range {\n  right: 126px;\n}\n\n.bs-datepicker.report-range {\n  top: 2px;\n  left: 180px;\n}\n\ntabset {\n  background-color: #fff;\n\n  ul.nav-tabs {\n    background-color: #fff;\n\n    a.nav-link {\n      border-width: 0 0 2px 0;\n      border-bottom: 2px solid transparent;\n      color: rgba(0, 0, 0, 0.87);\n      font-family: $fms-font-family;\n      font-size: 18px;\n      font-weight: bold;\n      min-width: 160px;\n      // opacity: 0.6;\n      padding: 7px 24px;\n      text-align: center;\n    }\n\n    a.nav-link.active,\n    a.nav-link:hover {\n      /*border-bottom: 2px solid rgba(0, 0, 0, .87);*/\n    }\n\n    a.nav-link.active {\n      background-color: #fff;\n      color: $fms-blue;\n      border-bottom: 2px solid $fms-blue;\n    }\n  }\n}\n\n.bck-white {\n  background: $fms-white;\n}\n\n.bck-gray {\n  background: $fms-gray-light;\n}\n\n.bck-blue {\n  background: $fms-blue;\n  color: $fms-white;\n}\n\n.bck-blue-light {\n  background: $fms-blue-light;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.white-box {\n  background-color: #fff;\n  padding: 1.5rem;\n}\n\n.blue-box {\n  background-color: $fms-blue-light;\n  padding: 1rem 1.5rem;\n}\n\n.light-gray-box {\n  background-color: $fms-gray-light;\n  padding: 0.75rem;\n}\n\n.card-body {\n  .main-container {\n    padding: 34px;\n  }\n}\n\ninput.rtl {\n  direction: rtl;\n}\n\n.flex-grow {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.no-flex-shrink {\n  flex-shrink: 0;\n}\n\n.navbar {\n  z-index: 100;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n.wide-modal {\n  max-width: 60vw !important;\n}\n\n.remove-icon {\n  color: $fms-red;\n  cursor: pointer;\n}\n\n.disabled-icon {\n  color: $fms-gray\n}\n\n.input-group.with-icon {\n  input.form-control {\n    border-right-width: 0;\n  }\n\n  .input-group-text {\n    background-color: #fff;\n  }\n}\n\n.badge.badge-button {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: block;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n  padding: 0 0.4em;\n}\n\na.disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n\n.task-tags {\n  height: 18px;\n  line-height: 0;\n  padding: 0;\n}\n\n.task-tag {\n  height: 18px;\n  font-size: 12px;\n  line-height: 18px;\n  padding: 0 8px;\n  border-radius: 9px;\n  margin-right: 5px;\n}\n\n.task-tag.category {\n  color: $fms-gray;\n  background-color: #e6e9f0;\n}\n\n.task-tag.type {\n  color: #151b26;\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-decoration-underline {\n  text-decoration: underline;\n}\n\n[ng-reflect-router-link] {\n  cursor: pointer;\n}\n\ni-feather.blue-icon {\n  color: $fms-blue;\n  cursor: pointer;\n}\n\ni-feather.white-icon {\n  color: $fms-white;\n  cursor: pointer;\n}\n\n\n.modal-dialog.modal-image {\n  width: auto;\n  max-width: initial;\n\n  .modal-content {\n    width: auto;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0;\n  }\n}\n\n.float-right {\n  float: right;\n}\n\n\n.color-yellow {\n  color: $fms-yellow;\n}\n\n@keyframes loading-indicator {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-indicator {\n  position: relative;\n}\n\n.loading-indicator .blocker {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  cursor: progress;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n\n.loading-indicator::after {\n  content: '';\n  box-sizing: border-box;\n  position: absolute;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  border-top-color: #07d;\n  border-bottom-color: #07d;\n  animation: .6s linear infinite loading-indicator;\n  z-index: 2;\n}\n\n.loading-indicator.for-dropdown::after {\n  bottom: 6px;\n  right: 6px;\n  width: 20px;\n  height: 20px;\n  background-color: #fff;\n}\n\n.loading-indicator.for-element::after {\n  top: calc(50% - 15px);\n  left: calc(50% - 15px);\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n}\n\n.star-icon, .star-icon::before {\n  font-size: 1em !important;\n  color: #8291ae !important;\n}\n\n.notifier__container {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\ntable.table {\n  margin-bottom: initial;\n}\n\n.sidenav-content {\n  height: 100%;\n\n  .sidenav-body {\n    padding: 25px 20px;\n    height: calc(100% - 60.5px);\n    overflow-y: auto;\n  }\n\n  .sidenav-footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.125);\n    padding: 12px 20px;\n  }\n}\n\n\n/* structure components styling */\n.Country-list {\n  border-right: solid 1px $fms-blue-light;\n  height: calc(100vh - 215px);\n}\n\n.Country-item {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  font-size: 14px;\n  font-weight: bold;\n  box-shadow: 0 -1px 0 0 $fms-blue-light;\n}\n\n.Country-header {\n  font-size: 18px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  font-weight: bold;\n}\n\n.country-detail-item {\n  color: $fms-white;\n  padding-left: 10px;\n  margin-top: 20px;\n  padding-top: 8px;\n  background: $fms-blue;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.governorate-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  color: $fms-blue;\n  background: $fms-blue-secondary;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.district-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  color: $fms-blue;\n  background: $fms-blue-light;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n\n.unit-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  background: $fms-gray-light;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n\nul.org-unit {\n  list-style: none;\n}\n\nul.org-unit li::before {\n  content: \" \";\n  color: $fms-blue;\n  font-size: 0px;\n  /* font-weight: bold; */\n  display: inline-block;\n  position: relative;\n  right: 35px;\n  top: -3px;\n  /* margin-left: 20em; */\n  background: $fms-blue;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n\nul.org-unit li::after {\n  content: \" \";\n  border-left: 1px solid $fms-blue;\n  border-bottom: 1px solid $fms-blue;\n  height: 50px !important;\n  top: -62px;\n  width: 16px;\n  position: relative;\n  display: block;\n  left: -50px;\n}\n\nul.org-unit > ul > li::after {\n  content: \" \";\n  border-left: 1px solid $fms-blue;\n  border-bottom: 1px solid $fms-blue;\n  height: 50px !important;\n  top: -62px;\n  width: 55px;\n  position: relative;\n  display: block;\n  left: -90px;\n}\n\nul.org-unit {\n  margin-bottom: 0 !important;\n}\n\n.no-children {\n  width: 32px;\n  height: 30px;\n}\n\nul.org-unit > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 95px;\n  position: relative;\n  display: block;\n  left: -130px;\n}\n\nul.org-unit > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 135px;\n  position: relative;\n  display: block;\n  left: -170px;\n}\n\nul.org-unit > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 175px;\n  position: relative;\n  display: block;\n  left: -210px;\n}\n\nul.org-unit > ul > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 215px;\n  position: relative;\n  display: block;\n  left: -250px;\n}\n\nul.org-unit > ul > ul > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 255px;\n  position: relative;\n  display: block;\n  left: -290px;\n}\n\n.nav-link.country-name {\n  padding: 0;\n}\n\n.country-name-container {\n  list-style-type: none;\n  padding: 0;\n}\n\n.country-name-container a {\n  color: white;\n}\n\n.country-name-container .nav-link {\n  color: #292727;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
